import { ArrowLongRightPdfIcon as e, Box as t, Button as n, Center as r, Divider as i, EmptyState as a, Flex as o, GreyGrey10 as s, GreyGrey100 as c, GreyGrey20 as l, GreyGrey30 as u, GreyGrey50 as ee, GreyGrey60 as d, GreyGrey70 as te, GreyGrey80 as f, GreyWhite as ne, Grid as p, GridItem as m, IconCreditCard as re, Image as ie, IndigoIndigo60 as ae, Lato12Bold as oe, Lato12Regular as se, Lato16Bold as ce, Lato24Bold as le, Modal as ue, Primary12SemiBold as de, Primary12UppercaseSemiBold as fe, Primary13Regular as h, Primary13SemiBold as pe, Primary14SemiBold as me, Primary16SemiBold as he, SequenceMenu as ge, Spinner as _e, Table as ve, Tbody as ye, Td as g, Text as _, Thead as be, Tooltip as xe, Tr as Se, Wordmark as Ce } from "@sequencehq/core-components";
import { formatAddress as v, formatDecimal as we, formatDecimalPlaces as Te, formatSortCode as Ee, localDateWithFormat as y, percentageFromDecimal as De, registerReactPdfFonts as Oe, toBankAccountTypeDescription as b, toCurrencyName as ke, toMoney as x, toPercentage as Ae } from "@sequencehq/utils";
import { Fragment as S, jsx as C, jsxs as w } from "react/jsx-runtime";
import { Document as je, Image as Me, Link as Ne, Page as Pe, Path as T, StyleSheet as Fe, Svg as Ie, Text as E, View as D } from "@react-pdf/renderer";
import { P as Le, match as O } from "ts-pattern";
import { formatDateRange as k, outputDateToApi as Re, parseISO as ze } from "@sequencehq/utils/dates";
import { forwardRef as Be, useEffect as Ve, useLayoutEffect as He, useMemo as Ue, useRef as We, useState as Ge } from "react";
import { Provider as Ke, atom as A, useAtom as qe, useAtomValue as j, useSetAtom as Je } from "jotai";
import { dequal as Ye } from "dequal";
import M from "big.js";
import { useHydrateAtoms as Xe } from "jotai/utils";
//#region \0rolldown/runtime.js
var Ze = Object.defineProperty, Qe = (e, t) => {
	let n = {};
	for (var r in e) Ze(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Ze(n, Symbol.toStringTag, { value: "Module" }), n;
}, N = ({ address: e }) => /* @__PURE__ */ C(_, {
	textStyle: "invoicePaymentContent",
	children: v(e).join(", ")
}), $e = ({ ukBankDetails: e, accountName: n, merchantAddress: r, includeBeneficiaryAddress: a }) => /* @__PURE__ */ w(S, { children: [
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Via UK bank transfer"
	}),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: n
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	a && /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: r })
	] }), /* @__PURE__ */ C(t, { h: "9px" })] }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Sort code"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.sortCode
		})
	] })
] }), et = ({ canadianInternationalDestination: e, merchantAddress: n, includeBeneficiaryAddress: r }) => /* @__PURE__ */ w(S, { children: [
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(o, { children: /* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Beneficiary"
	}) }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Legal name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.legalName
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	r && /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: n })
	] }), /* @__PURE__ */ C(t, { h: "9px" })] }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Transit number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.transitNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ C(o, { children: /* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Beneficiary bank"
	}) }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.bankName
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: e.bankAddress })
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Institution number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.institutionNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Swift code"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.swiftCode
		})
	] }),
	e.intermediaryBank && /* @__PURE__ */ w(S, { children: [
		/* @__PURE__ */ C(t, { h: "9px" }),
		/* @__PURE__ */ C(o, { children: /* @__PURE__ */ C(_, {
			textStyle: "infoText",
			children: "Intermediary bank"
		}) }),
		/* @__PURE__ */ C(t, { h: "9px" }),
		/* @__PURE__ */ w(o, { children: [
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Bank name"
			}),
			/* @__PURE__ */ C(t, { w: "16px" }),
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentContent",
				children: e.intermediaryBank.bankName
			})
		] }),
		/* @__PURE__ */ C(t, { h: "9px" }),
		/* @__PURE__ */ w(o, { children: [
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Bank address"
			}),
			/* @__PURE__ */ C(t, { w: "16px" }),
			/* @__PURE__ */ C(N, { address: e.intermediaryBank.bankAddress })
		] }),
		/* @__PURE__ */ C(t, { h: "9px" }),
		/* @__PURE__ */ w(o, { children: [
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Routing number"
			}),
			/* @__PURE__ */ C(t, { w: "16px" }),
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentContent",
				children: e.intermediaryBank.routingNumber
			})
		] }),
		/* @__PURE__ */ C(t, { h: "9px" }),
		/* @__PURE__ */ w(o, { children: [
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Swift code"
			}),
			/* @__PURE__ */ C(t, { w: "16px" }),
			/* @__PURE__ */ C(_, {
				textStyle: "invoicePaymentContent",
				children: e.intermediaryBank.swiftCode
			})
		] })
	] })
] }), tt = ({ canadianBankDetails: e, accountName: n, merchantAddress: r, includeBeneficiaryAddress: a }) => /* @__PURE__ */ w(S, { children: [
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Via Canadian bank transfer"
	}),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: n
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	a && /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: r })
	] }), /* @__PURE__ */ C(t, { h: "9px" })] }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Transit number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.transitNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Institution number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.institutionNumber
		})
	] })
] }), nt = ({ iban: e, accountName: n, merchantAddress: r, includeBeneficiaryAddress: a }) => /* @__PURE__ */ w(S, { children: [
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Via bank transfer"
	}),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: n
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	a && /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: r })
	] }), /* @__PURE__ */ C(t, { h: "9px" })] }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "IBAN"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e
		})
	] })
] }), rt = ({ achDetails: e, merchantAddress: n, includeBeneficiaryAddress: r }) => /* @__PURE__ */ w(S, { children: [
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Via ACH"
	}),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountName
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	r && /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: n })
	] }), /* @__PURE__ */ C(t, { h: "9px" })] }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.bankName
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank routing number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.bankRoutingNumber
		})
	] })
] }), it = ({ wireDetails: e, merchantAddress: n, includeBeneficiaryAddress: r }) => /* @__PURE__ */ w(S, { children: [
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ C(t, { h: "8px" }),
	/* @__PURE__ */ C(_, {
		textStyle: "infoText",
		children: "Via Wire"
	}),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountName
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	r && /* @__PURE__ */ w(S, { children: [/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: n })
	] }), /* @__PURE__ */ C(t, { h: "9px" })] }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank name"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.bankName
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank routing number"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			children: e.bankRoutingNumber
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Swift code"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentContent",
			textAlign: "right",
			children: e.swiftCode
		})
	] }),
	/* @__PURE__ */ C(t, { h: "9px" }),
	/* @__PURE__ */ w(o, { children: [
		/* @__PURE__ */ C(_, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank address"
		}),
		/* @__PURE__ */ C(t, { w: "16px" }),
		/* @__PURE__ */ C(N, { address: e.bankAddress })
	] })
] }), P = (e) => e.match(/\w+|\W+/g)?.map((e) => e.replace(/ /g, "\xA0")), F = (e) => {
	let t = Number(e.fontSize.replace("px", "")), n = Number(e.lineHeight.replace("px", ""));
	return {
		...e,
		fontSize: t,
		lineHeight: n / t
	};
}, at = (e, t) => {
	let n = Math.ceil(e.length / t);
	return Array.from({ length: n }, (n, r) => e.slice(r * t, r * t + t));
}, I = Fe.create({
	page: {
		backgroundColor: "white",
		paddingBottom: 89,
		paddingTop: 32
	},
	wrapper: {
		paddingLeft: 24,
		paddingRight: 24
	},
	pageAccent: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: 4
	},
	pageFooter: {
		position: "absolute",
		bottom: 0,
		left: 0,
		width: "100%",
		padding: 24
	},
	pageSeparator: {
		height: 1,
		backgroundColor: u
	},
	watermark: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100vw",
		height: "100vh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	watermarkText: {
		fontFamily: "Lato",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 144,
		textTransform: "uppercase",
		opacity: .3,
		transform: "rotate(-45deg)"
	},
	sectionHeader: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 16
	},
	sectionSummary: {
		display: "flex",
		flexDirection: "row",
		gap: 16,
		marginBottom: 24
	},
	sectionInvoicePaymentOverview: {
		marginBottom: 24,
		gap: 8
	},
	lato24BoldGreyGrey100: {
		...F(le),
		color: c
	},
	lato24BoldGreyGrey80: {
		...F(le),
		color: f
	},
	lato16BoldGreyGrey100: {
		...F(ce),
		color: c
	},
	lato16BoldGreyGrey80: {
		...F(ce),
		color: f
	},
	lato12RegularGreyGrey100: {
		...F(se),
		color: c
	},
	lato12RegularGreyGrey80: {
		...F(se),
		color: f
	},
	lato12RegularGreyGrey60: {
		...F(se),
		color: d
	},
	lato12BoldGreyGrey100: {
		...F(oe),
		color: c
	},
	lato12BoldGreyGrey80: {
		...F(oe),
		color: f
	},
	lato12BoldLink: {
		...F(oe),
		color: ae,
		textDecoration: "none"
	}
}), { lato12BoldGreyGrey80: ot, lato12RegularGreyGrey80: L } = I, st = ({ style: e, heading: t, name: n, address: r, phoneNumber: i, email: a, taxId: o }) => {
	let s = v(r);
	return /* @__PURE__ */ w(D, {
		style: e,
		children: [
			/* @__PURE__ */ C(E, {
				style: ot,
				children: t
			}),
			n && /* @__PURE__ */ C(E, {
				style: L,
				children: n
			}),
			s.map((e, t) => /* @__PURE__ */ C(E, {
				style: L,
				children: e
			}, t)),
			i && /* @__PURE__ */ C(E, {
				style: L,
				children: i
			}),
			a && /* @__PURE__ */ C(E, {
				style: L,
				children: a
			}),
			o && /* @__PURE__ */ w(E, {
				style: L,
				children: ["Tax ID: ", o]
			})
		]
	});
}, { sectionInvoicePaymentOverview: ct, lato16BoldGreyGrey80: lt } = I, ut = ({ creditNote: { currency: e, grossTotal: t } }) => /* @__PURE__ */ C(D, {
	style: ct,
	children: /* @__PURE__ */ C(E, {
		style: lt,
		children: x({
			currency: e,
			value: t,
			appendCurrencyCode: !0
		})
	})
}), R = (e) => O(e).with("creditNoteNumber", () => "Credit note number").with("invoiceNumber", () => "Related invoice").with("issueDate", () => "Date of issue").with("purchaseOrderNumber", () => "Purchase order").with("billingPeriod", () => "Billing period").exhaustive(), dt = (e) => e || "Pending", ft = (e) => e ? y(e, "d MMMM yyyy") : "Pending issuing", pt = (e) => k({
	from: new Date(e.start),
	to: new Date(e.endInclusive),
	separator: "-"
}), mt = ({ lineItem: e, currency: t }) => e.rateDisplay === "PERCENTAGE" ? x({
	currency: t,
	value: e.quantity
}) : e.quantity, ht = ({ lineItem: e, currency: t }) => e.rateDisplay === "PERCENTAGE" ? Ae(De(e.rate)) : x({
	currency: t,
	value: e.rate,
	maximumFractionDigits: 10
}), gt = ({ lineItem: e }) => Ae(De(e.taxRate)), _t = ({ lineItem: e, currency: t }) => x({
	currency: t,
	value: e.netTotal
}), { sectionSummary: vt, lato12RegularGreyGrey80: yt } = I, bt = ({ creditNote: e, merchantDetails: t }) => {
	let { invoiceNumber: n, purchaseOrderNumber: r, issueDate: i, memo: a, customerLegalCompanyName: o, customerBillingAddress: s, customerTaxId: c, creditNoteNumber: l, billingPeriodStart: u, billingPeriodEnd: ee } = e;
	return /* @__PURE__ */ w(D, {
		style: vt,
		children: [/* @__PURE__ */ w(D, {
			style: {
				width: 312,
				gap: 16
			},
			children: [
				/* @__PURE__ */ w(D, { children: [
					/* @__PURE__ */ C(Ct, {
						title: R("creditNoteNumber"),
						value: l || "Pending"
					}),
					r && /* @__PURE__ */ C(Ct, {
						title: R("purchaseOrderNumber"),
						value: r
					}),
					n && /* @__PURE__ */ C(Ct, {
						title: R("invoiceNumber"),
						value: n
					}),
					u && ee && /* @__PURE__ */ C(Ct, {
						title: R("billingPeriod"),
						value: pt({
							start: u,
							endInclusive: ee
						})
					}),
					/* @__PURE__ */ C(Ct, {
						title: R("issueDate"),
						value: ft(i)
					})
				] }),
				/* @__PURE__ */ C(st, {
					heading: "Credited to",
					name: o,
					address: s,
					taxId: c,
					customerCountry: s?.country
				}),
				a && /* @__PURE__ */ C(E, {
					style: yt,
					children: a
				})
			]
		}), t && /* @__PURE__ */ C(st, {
			style: {
				flex: 1,
				textAlign: "right"
			},
			heading: t.legalCompanyName,
			address: t.address,
			phoneNumber: t.phoneNumber,
			email: t.email,
			taxId: t.taxId,
			customerCountry: s?.country
		})]
	});
}, { lato12RegularGreyGrey80: xt, lato12BoldGreyGrey80: St } = I, Ct = ({ title: e, value: t }) => /* @__PURE__ */ w(D, {
	style: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap"
	},
	children: [
		P(`${e}:`)?.map((e, t) => /* @__PURE__ */ C(E, {
			style: St,
			children: e
		}, t)),
		/* @__PURE__ */ C(E, {
			style: St,
			children: " "
		}),
		P(t)?.map((e, t) => /* @__PURE__ */ C(E, {
			style: xt,
			children: e
		}, t))
	]
}), { lato12BoldGreyGrey100: wt } = I, Tt = ({ title: e, currency: t, netTotal: n, totalTax: r, grossTotal: i, finalTotalLabel: a }) => /* @__PURE__ */ w(D, {
	style: {
		minWidth: 244,
		marginBottom: "16px"
	},
	children: [
		e && /* @__PURE__ */ C(E, {
			style: wt,
			children: e
		}),
		/* @__PURE__ */ C(kt, {
			title: "Subtotal",
			value: x({
				currency: t,
				value: n
			})
		}),
		/* @__PURE__ */ C(kt, {
			title: "Tax",
			value: x({
				currency: t,
				value: r
			})
		}),
		/* @__PURE__ */ C(kt, {
			title: a,
			value: x({
				currency: t,
				value: i,
				appendCurrencyCode: !0
			}),
			textStyle: wt,
			borderBottom: 0
		})
	]
}), Et = ({ creditNote: e, refTotalsPage: t }) => {
	let { currency: n, netTotal: r, grossTotal: i, totalTax: a } = e;
	return /* @__PURE__ */ w(D, {
		style: {
			display: "flex",
			alignItems: "flex-end"
		},
		wrap: !1,
		children: [/* @__PURE__ */ C(D, {
			style: { minWidth: 244 },
			children: /* @__PURE__ */ C(Tt, {
				currency: n,
				netTotal: r,
				totalTax: a,
				grossTotal: i,
				finalTotalLabel: "Credit total"
			})
		}), /* @__PURE__ */ C(E, {
			render: ({ pageNumber: e }) => (t.current = e, ""),
			style: { display: "none" }
		})]
	});
}, { lato12RegularGreyGrey100: Dt } = I, Ot = {
	display: "flex",
	flexDirection: "row",
	borderBottom: 1,
	borderBottomStyle: "solid",
	borderBottomColor: u,
	paddingTop: 7,
	paddingBottom: 7,
	justifyContent: "space-between",
	gap: 16
}, kt = ({ title: e, value: t, textStyle: n = Dt, borderBottom: r }) => /* @__PURE__ */ w(D, {
	style: {
		...Ot,
		...r === void 0 ? {} : { borderBottom: r }
	},
	children: [/* @__PURE__ */ C(E, {
		style: { ...n },
		children: e
	}), /* @__PURE__ */ C(E, {
		style: {
			...n,
			textAlign: "right"
		},
		children: t
	})]
}), { lato24BoldGreyGrey100: At, lato16BoldGreyGrey100: jt, sectionHeader: Mt } = I, Nt = ({ merchantDetails: e, isRenderedInBrowser: t }) => /* @__PURE__ */ w(D, {
	style: Mt,
	children: [/* @__PURE__ */ C(E, {
		style: At,
		children: "Credit note"
	}), e.logoUrl ? /* @__PURE__ */ C(Pt, {
		logoUrl: e.logoUrl,
		isRenderedInBrowser: t
	}) : /* @__PURE__ */ C(E, {
		style: jt,
		children: e.legalCompanyName
	})]
}), Pt = ({ logoUrl: e, isRenderedInBrowser: t }) => /* @__PURE__ */ C(D, { children: /* @__PURE__ */ C(Me, {
	src: t ? {
		uri: e,
		method: "GET",
		headers: { "Cache-Control": "no-cache" },
		body: ""
	} : e,
	style: { height: 28 }
}) }), { pageAccent: Ft } = I, It = ({ merchantDetails: e }) => {
	let t = e.primaryColour ?? "transparent";
	return /* @__PURE__ */ C(D, {
		style: {
			...Ft,
			backgroundColor: t
		},
		fixed: !0
	});
}, { pageFooter: Lt, pageSeparator: Rt, lato12RegularGreyGrey80: zt } = I, Bt = ({ text: e, refTotalsPage: t }) => /* @__PURE__ */ C(D, {
	style: Lt,
	fixed: !0,
	children: /* @__PURE__ */ C(D, {
		style: {
			display: "flex",
			gap: 24,
			justifyContent: "flex-end"
		},
		render: ({ pageNumber: n }) => /* @__PURE__ */ w(S, { children: [
			n === t.current && /* @__PURE__ */ C(Ht, {}),
			/* @__PURE__ */ C(D, { style: Rt }),
			/* @__PURE__ */ w(D, {
				style: {
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					width: "100%"
				},
				children: [/* @__PURE__ */ C(E, {
					style: zt,
					children: e
				}), /* @__PURE__ */ C(E, {
					style: zt,
					render: ({ totalPages: e }) => `Page ${n} of ${e}`
				})]
			})
		] })
	})
}), { lato12RegularGreyGrey80: Vt } = I, Ht = () => /* @__PURE__ */ w(Ne, {
	href: "https://sequencehq.com?utm_campaign=pdf-credit-note",
	style: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		textDecoration: "none"
	},
	children: [/* @__PURE__ */ C(E, {
		style: {
			...Vt,
			marginRight: 4
		},
		children: "Powered by"
	}), /* @__PURE__ */ C(Ut, {})]
}), Ut = () => /* @__PURE__ */ w(Ie, {
	width: "65",
	height: "15",
	viewBox: "0 0 65 15",
	fill: "none",
	style: {
		width: 65,
		height: 15
	},
	children: [
		/* @__PURE__ */ C(T, {
			d: "M5.36707 11.4172C6.63874 11.4172 7.64425 11.1422 8.36881 10.5923C9.09336 10.0424 9.46304 9.28989 9.46304 8.33478C9.46304 7.53886 9.19687 6.90212 8.66455 6.42457C8.13222 5.96149 7.27458 5.59971 6.07684 5.33922L5.16006 5.15109C4.27285 4.97744 3.68137 4.7459 3.35606 4.48541C3.03075 4.25387 2.86809 3.89209 2.86809 3.41454C2.86809 2.95145 3.04554 2.60414 3.41521 2.34366C3.77009 2.09765 4.30242 1.9674 4.9974 1.9674C5.88461 1.9674 6.52045 2.12659 6.9197 2.44496C7.31894 2.76333 7.54074 3.24088 7.59989 3.90656H9.1673C9.13772 2.89357 8.78284 2.09765 8.08786 1.51879C7.39287 0.93994 6.35779 0.650513 4.98262 0.650513C3.82924 0.650513 2.92724 0.910997 2.26183 1.41749C1.58164 1.92399 1.25632 2.60414 1.25632 3.44348C1.25632 4.29729 1.52249 4.96297 2.08439 5.44052C2.6315 5.93255 3.44478 6.27986 4.53901 6.48246L5.44101 6.67058C6.32822 6.87318 6.94927 7.09025 7.30415 7.33626C7.64425 7.58228 7.82169 7.92959 7.82169 8.3782C7.82169 8.94258 7.59989 9.37672 7.18586 9.66615C6.77183 9.95557 6.16557 10.1003 5.39665 10.1003C3.50393 10.1003 2.55757 9.33331 2.528 7.78487H0.945801C0.945801 8.97152 1.34505 9.88322 2.11396 10.491C2.88288 11.1133 3.97711 11.4172 5.36707 11.4172Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M17.4455 7.50992C17.4455 6.35221 17.1202 5.41158 16.4843 4.65907C15.8337 3.92103 14.9465 3.54478 13.8227 3.54478C12.7433 3.54478 11.8708 3.90656 11.2054 4.61565C10.5252 5.33922 10.1999 6.27986 10.1999 7.45203C10.1999 8.63868 10.5252 9.57932 11.2054 10.2884C11.8708 11.012 12.758 11.3593 13.8523 11.3593C14.7247 11.3593 15.464 11.1422 16.0555 10.7081C16.647 10.2739 17.061 9.66615 17.268 8.89917H15.7746C15.4788 9.7385 14.843 10.1437 13.8818 10.1437C13.2312 10.1437 12.7285 9.97005 12.3588 9.59379C11.9743 9.21754 11.7525 8.66763 11.6934 7.92959H17.4455V7.50992ZM13.8227 4.76037C14.4142 4.76037 14.8873 4.9485 15.257 5.32475C15.6267 5.701 15.8485 6.17856 15.9224 6.78635H11.7082C11.7969 6.13514 12.0187 5.62865 12.3884 5.28134C12.758 4.93402 13.2312 4.76037 13.8227 4.76037Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M24.1135 4.81825C23.5368 3.97892 22.694 3.54478 21.585 3.54478C20.5203 3.54478 19.6627 3.90656 19.0416 4.60118C18.4058 5.31028 18.0952 6.26539 18.0952 7.45203C18.0952 8.65315 18.4058 9.60826 19.0416 10.3029C19.6627 11.012 20.5203 11.3593 21.585 11.3593C22.6496 11.3593 23.4777 10.9686 24.0544 10.1726V14.022H25.533V3.71843H24.1135V4.81825ZM20.2393 9.43461C19.8253 8.98599 19.6331 8.34926 19.6331 7.50992C19.6331 6.67058 19.8253 6.0049 20.2393 5.51288C20.6386 5.03532 21.1857 4.78931 21.8659 4.78931C22.5609 4.78931 23.108 5.02085 23.5072 5.48393C23.8917 5.96149 24.0987 6.6127 24.0987 7.45203C24.0987 8.30584 23.8917 8.95705 23.5072 9.40566C23.108 9.88322 22.5609 10.1148 21.8659 10.1148C21.1857 10.1148 20.6386 9.89769 20.2393 9.43461Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M31.9069 7.92959C31.9069 8.60974 31.7147 9.14518 31.3451 9.52143C30.9754 9.89769 30.517 10.0858 29.9847 10.0858C28.9052 10.0858 28.3729 9.56485 28.3729 8.52291V3.71843H26.8942V8.72551C26.8942 9.56485 27.1308 10.2016 27.604 10.6647C28.0772 11.1278 28.7278 11.3593 29.5706 11.3593C30.5761 11.3593 31.3746 10.9396 31.9661 10.0713V11.1856H33.3856V3.71843H31.9069V7.92959Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M41.6369 7.50992C41.6369 6.35221 41.3116 5.41158 40.6758 4.65907C40.0251 3.92103 39.1379 3.54478 38.0141 3.54478C36.9347 3.54478 36.0623 3.90656 35.3968 4.61565C34.7166 5.33922 34.3913 6.27986 34.3913 7.45203C34.3913 8.63868 34.7166 9.57932 35.3968 10.2884C36.0623 11.012 36.9495 11.3593 38.0437 11.3593C38.9161 11.3593 39.6555 11.1422 40.2469 10.7081C40.8384 10.2739 41.2524 9.66615 41.4595 8.89917H39.966C39.6702 9.7385 39.0344 10.1437 38.0733 10.1437C37.4226 10.1437 36.9199 9.97005 36.5502 9.59379C36.1658 9.21754 35.944 8.66763 35.8848 7.92959H41.6369V7.50992ZM38.0141 4.76037C38.6056 4.76037 39.0788 4.9485 39.4484 5.32475C39.8181 5.701 40.0399 6.17856 40.1139 6.78635H35.8996C35.9883 6.13514 36.2101 5.62865 36.5798 5.28134C36.9495 4.93402 37.4226 4.76037 38.0141 4.76037Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M46.4566 3.54478C45.4363 3.54478 44.6378 3.97892 44.0611 4.83273V3.71843H42.6416V11.1856H44.1202V6.97448C44.1202 6.27986 44.3125 5.74442 44.7117 5.36816C45.0962 5.00638 45.5398 4.81825 46.0425 4.81825C47.1072 4.81825 47.6543 5.33922 47.6543 6.38116V11.1856H49.133V6.17856C49.133 5.33922 48.8964 4.70248 48.4232 4.2394C47.95 3.77632 47.2846 3.54478 46.4566 3.54478Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M53.7763 11.3593C54.693 11.3593 55.462 11.1133 56.083 10.5923C56.7041 10.0858 57.0737 9.39119 57.192 8.52291H55.6838C55.595 9.04388 55.3732 9.43461 55.0331 9.69509C54.6783 9.97004 54.2642 10.1003 53.7763 10.1003C53.1256 10.1003 52.6229 9.88322 52.2384 9.42013C51.854 8.95705 51.6765 8.30584 51.6765 7.45203C51.6765 6.6127 51.854 5.96149 52.2384 5.49841C52.6229 5.03532 53.1256 4.80378 53.7763 4.80378C54.2494 4.80378 54.6635 4.93402 55.0036 5.19451C55.3437 5.45499 55.5655 5.83125 55.669 6.32327H57.1772C57.0589 5.48393 56.6893 4.80378 56.083 4.29729C55.4767 3.80526 54.7078 3.54478 53.7763 3.54478C52.682 3.54478 51.7948 3.90656 51.1442 4.60118C50.464 5.32475 50.1387 6.26539 50.1387 7.45203C50.1387 8.63868 50.464 9.57932 51.1442 10.2884C51.8096 11.012 52.682 11.3593 53.7763 11.3593Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ C(T, {
			d: "M64.9475 7.50992C64.9475 6.35221 64.6222 5.41158 63.9863 4.65907C63.3357 3.92103 62.4485 3.54478 61.3247 3.54478C60.2452 3.54478 59.3728 3.90656 58.7074 4.61565C58.0272 5.33922 57.7019 6.27986 57.7019 7.45203C57.7019 8.63868 58.0272 9.57932 58.7074 10.2884C59.3728 11.012 60.26 11.3593 61.3543 11.3593C62.2267 11.3593 62.966 11.1422 63.5575 10.7081C64.149 10.2739 64.563 9.66615 64.77 8.89917H63.2765C62.9808 9.7385 62.345 10.1437 61.3838 10.1437C60.7332 10.1437 60.2304 9.97005 59.8608 9.59379C59.4763 9.21754 59.2545 8.66763 59.1954 7.92959H64.9475V7.50992ZM61.3247 4.76037C61.9162 4.76037 62.3893 4.9485 62.759 5.32475C63.1287 5.701 63.3505 6.17856 63.4244 6.78635H59.2102C59.2989 6.13514 59.5207 5.62865 59.8904 5.28134C60.26 4.93402 60.7332 4.76037 61.3247 4.76037Z",
			fill: "#241F25"
		})
	]
}), { lato12BoldGreyGrey100: Wt, lato12RegularGreyGrey60: Gt } = I, Kt = ({ primaryText: e, secondaryText: t, children: n, style: r }) => {
	let i = !!e || !!t;
	return /* @__PURE__ */ w(D, {
		style: r?.container,
		children: [i && /* @__PURE__ */ w(D, {
			style: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				...r?.header ?? {}
			},
			children: [
				e && P(e)?.map((e, t) => /* @__PURE__ */ C(E, {
					style: {
						...Wt,
						minWidth: "1"
					},
					hyphenationCallback: (e) => at(e, 78),
					children: e
				}, t)),
				t && /* @__PURE__ */ C(E, {
					style: Wt,
					children: "   "
				}),
				t && P(t)?.map((e, t) => /* @__PURE__ */ C(E, {
					style: Gt,
					hyphenationCallback: (e) => at(e, 78),
					children: e
				}, t))
			]
		}), n]
	});
}, { lato12RegularGreyGrey100: qt, lato12RegularGreyGrey60: Jt } = I, z = ({ wrap: e = !1, value: t, secondaryValue: n, width: r, textAlign: i = "right", paddingLeft: a = 8, paddingRight: o = 8, paddingTop: s = 11, paddingBottom: c = 8, fontStyle: l = qt, secondaryFontStyle: u = Jt }) => /* @__PURE__ */ w(D, {
	style: {
		paddingTop: s,
		paddingBottom: c,
		paddingLeft: a,
		paddingRight: o,
		width: r === void 0 ? void 0 : r + a + o,
		...r === void 0 ? { flex: 1 } : {}
	},
	children: [e ? /* @__PURE__ */ C(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap"
		},
		children: P(t)?.map((e, t) => /* @__PURE__ */ C(E, {
			style: {
				...l,
				minWidth: "1",
				maxWidth: "100%"
			},
			hyphenationCallback: (e) => at(e, 32),
			children: e
		}, t))
	}) : /* @__PURE__ */ C(E, {
		style: {
			...l,
			textAlign: i,
			width: "100%"
		},
		children: t
	}), n && /* @__PURE__ */ C(S, { children: e ? /* @__PURE__ */ C(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap"
		},
		children: P(n)?.map((e, t) => /* @__PURE__ */ C(E, {
			style: {
				...u,
				minWidth: "1",
				maxWidth: "100%"
			},
			hyphenationCallback: (e) => at(e, 32),
			children: e
		}, t))
	}) : /* @__PURE__ */ C(E, {
		style: u,
		children: n
	}) })]
}), Yt = ({ children: e, borderBottom: t }) => /* @__PURE__ */ C(D, {
	style: {
		display: "flex",
		flexDirection: "row",
		...t === void 0 ? {} : {
			borderBottom: 1,
			borderBottomColor: t,
			borderBottomStyle: "solid"
		}
	},
	wrap: !1,
	children: e
}), B = {
	description: {
		value: "Description",
		paddingLeft: 0,
		textAlign: "left"
	},
	quantity: {
		value: "Qty",
		width: 52
	},
	rate: {
		value: "Rate",
		width: 88
	},
	taxRate: {
		value: "Tax",
		width: 46
	},
	netTotal: {
		value: "Price",
		width: 90,
		paddingRight: 0
	}
}, Xt = /* @__PURE__ */ Qe({
	avg: () => Zt,
	default: () => Qt
}), Zt = 6.3101292775665465, Qt = {
	0: 0,
	13: 0,
	32: 2.316,
	33: 4.116,
	34: 4.764,
	35: 6.96,
	36: 6.96,
	37: 9.432,
	38: 8.436,
	39: 2.7600000000000002,
	40: 3.6,
	41: 3.6,
	42: 4.8,
	43: 6.96,
	44: 2.544,
	45: 4.164,
	46: 2.544,
	47: 4.476,
	48: 6.96,
	49: 6.96,
	50: 6.96,
	51: 6.96,
	52: 6.96,
	53: 6.96,
	54: 6.96,
	55: 6.96,
	56: 6.96,
	57: 6.96,
	58: 3.024,
	59: 3.024,
	60: 6.96,
	61: 6.96,
	62: 6.96,
	63: 4.776,
	64: 9.864,
	65: 8.16,
	66: 7.764,
	67: 8.22,
	68: 9.036,
	69: 6.972,
	70: 6.792,
	71: 8.808,
	72: 9.072000000000001,
	73: 3.684,
	74: 5.328,
	75: 8.172,
	76: 6.168,
	77: 11.040000000000001,
	78: 9.072000000000001,
	79: 9.576,
	80: 7.332,
	81: 9.576,
	82: 7.728,
	83: 6.36,
	84: 7.08,
	85: 8.76,
	86: 8.16,
	87: 12.228,
	88: 7.716,
	89: 7.548,
	90: 7.488,
	91: 3.6,
	92: 4.5,
	93: 3.6,
	94: 6.96,
	95: 4.728,
	96: 3.684,
	97: 6.0840000000000005,
	98: 6.708,
	99: 5.604,
	100: 6.708,
	101: 6.288,
	102: 4.0440000000000005,
	103: 6.132000000000001,
	104: 6.672,
	105: 3.072,
	106: 3.048,
	107: 6.288,
	108: 3.072,
	109: 9.852,
	110: 6.672,
	111: 6.672,
	112: 6.6240000000000006,
	113: 6.708,
	114: 4.836,
	115: 5.208,
	116: 4.476,
	117: 6.672,
	118: 6.144,
	119: 9.192,
	120: 6.048,
	121: 6.144,
	122: 5.5440000000000005,
	123: 3.6,
	124: 3.6,
	125: 3.6,
	126: 6.96,
	160: 2.316,
	161: 4.116,
	162: 6.96,
	163: 6.96,
	164: 6.96,
	165: 6.96,
	166: 3.6,
	167: 6.0360000000000005,
	168: 3.684,
	169: 9.576,
	170: 4.104,
	171: 5.556,
	172: 6.96,
	173: 4.164,
	174: 9.576,
	175: 3.684,
	176: 4.764,
	177: 6.96,
	178: 3.984,
	179: 3.984,
	180: 3.684,
	181: 6.672,
	182: 8.028,
	183: 3.2760000000000002,
	184: 3.684,
	185: 3.984,
	186: 4.572,
	187: 5.556,
	188: 8.544,
	189: 8.544,
	190: 8.556000000000001,
	191: 4.776,
	192: 8.16,
	193: 8.16,
	194: 8.16,
	195: 8.16,
	196: 8.16,
	197: 8.16,
	198: 11.148,
	199: 8.22,
	200: 6.972,
	201: 6.972,
	202: 6.972,
	203: 6.972,
	204: 3.684,
	205: 3.684,
	206: 3.684,
	207: 3.684,
	208: 9.468,
	209: 9.072000000000001,
	210: 9.576,
	211: 9.576,
	212: 9.576,
	213: 9.576,
	214: 9.576,
	215: 6.96,
	216: 9.576,
	217: 8.76,
	218: 8.76,
	219: 8.76,
	220: 8.76,
	221: 7.548,
	222: 7.332,
	223: 7.308,
	224: 6.0840000000000005,
	225: 6.0840000000000005,
	226: 6.0840000000000005,
	227: 6.0840000000000005,
	228: 6.0840000000000005,
	229: 6.0840000000000005,
	230: 9.792,
	231: 5.604,
	232: 6.288,
	233: 6.288,
	234: 6.288,
	235: 6.288,
	236: 3.072,
	237: 3.072,
	238: 3.072,
	239: 3.072,
	240: 6.636,
	241: 6.672,
	242: 6.672,
	243: 6.672,
	244: 6.672,
	245: 6.672,
	246: 6.672,
	247: 6.96,
	248: 6.672,
	249: 6.672,
	250: 6.672,
	251: 6.672,
	252: 6.672,
	253: 6.144,
	254: 6.6240000000000006,
	255: 6.144,
	260: 8.16,
	261: 6.0840000000000005,
	262: 8.22,
	263: 5.604,
	280: 7.128,
	281: 6.288,
	305: 3.072,
	321: 6.516,
	322: 3.852,
	323: 9.072000000000001,
	324: 6.672,
	338: 13.152000000000001,
	339: 10.404,
	346: 6.5760000000000005,
	347: 5.208,
	352: 6.36,
	353: 5.208,
	376: 7.548,
	377: 7.488,
	378: 5.5440000000000005,
	379: 7.488,
	380: 5.5440000000000005,
	381: 7.488,
	382: 5.5440000000000005,
	402: 6.96,
	710: 3.684,
	711: 3.684,
	713: 3.684,
	728: 3.684,
	729: 3.684,
	730: 3.684,
	731: 3.684,
	732: 3.684,
	733: 3.684,
	960: 7.416,
	8211: 6.672,
	8212: 9.852,
	8216: 2.544,
	8217: 2.544,
	8218: 2.544,
	8220: 4.368,
	8221: 4.368,
	8222: 4.368,
	8224: 6.96,
	8225: 6.96,
	8226: 6.96,
	8230: 8.724,
	8240: 13.836,
	8249: 3.7920000000000003,
	8250: 3.7920000000000003,
	8260: 3.684,
	8364: 6.96,
	8482: 8.64,
	8486: 8.964,
	8706: 6.96,
	8710: 8.352,
	8719: 8.208,
	8721: 8.208,
	8722: 6.96,
	8730: 6.876,
	8734: 8.208,
	8747: 4.8,
	8776: 6.96,
	8800: 6.96,
	8804: 6.96,
	8805: 6.96,
	9674: 6.96,
	9833: 0,
	64257: 6.84,
	64258: 7.128,
	avg: Zt
}, $t = (e) => e in Xt, en = (e) => {
	let t = e.charCodeAt(0).toString();
	return $t(t) ? Xt[t] : Zt;
}, tn = (e) => e.split("").map((e) => en(e)).reduce((e, t) => e + t, 0), nn = (e) => e.length === 0 ? 0 : Math.max(...e.map(tn)), rn = ({ minWidth: e, width: t }) => e !== void 0 && t < e ? e : t, an = ({ lineItems: e, currency: t }) => ({
	description: 0,
	quantity: nn(e.map((e) => mt({
		lineItem: e,
		currency: t
	}))),
	rate: nn(e.map((e) => ht({
		lineItem: e,
		currency: t
	}))),
	taxRate: nn(e.map((e) => gt({ lineItem: e }))),
	netTotal: nn(e.map((e) => _t({
		lineItem: e,
		currency: t
	})))
}), { lato12RegularGreyGrey100: on, lato12RegularGreyGrey60: sn } = I, cn = ({ lineItem: e, creditNote: t, columnWidths: n, servicePeriod: r }) => {
	let { currency: i } = t;
	return /* @__PURE__ */ w(Yt, {
		borderBottom: u,
		children: [
			/* @__PURE__ */ C(ln, {
				title: e.title,
				description: e.description,
				servicePeriod: r
			}),
			/* @__PURE__ */ C(z, {
				value: mt({
					lineItem: e,
					currency: i
				}),
				width: rn({
					minWidth: B.quantity.width,
					width: n.quantity
				})
			}),
			/* @__PURE__ */ C(z, {
				value: ht({
					lineItem: e,
					currency: i
				}),
				width: rn({
					minWidth: B.rate.width,
					width: n.rate
				})
			}),
			/* @__PURE__ */ C(z, {
				value: gt({ lineItem: e }),
				width: rn({
					minWidth: B.taxRate.width,
					width: n.taxRate
				})
			}),
			/* @__PURE__ */ C(z, {
				value: _t({
					lineItem: e,
					currency: i
				}),
				width: rn({
					minWidth: B.netTotal.width,
					width: n.netTotal
				}),
				paddingRight: B.netTotal.paddingRight
			})
		]
	});
}, ln = ({ title: e, description: t, servicePeriod: n }) => /* @__PURE__ */ w(D, {
	style: {
		paddingTop: 11,
		paddingBottom: 8,
		paddingLeft: B.description.paddingLeft,
		paddingRight: 8,
		flex: 1,
		display: "flex",
		flexDirection: "column"
	},
	children: [
		/* @__PURE__ */ C(E, {
			style: on,
			children: e
		}),
		t && /* @__PURE__ */ C(E, {
			style: sn,
			children: t
		}),
		n && /* @__PURE__ */ C(E, {
			style: sn,
			children: n
		})
	]
});
//#endregion
//#region src/utils/formatServicePeriod.ts
function un({ start: e, end: t, fallbackStart: n, fallbackEnd: r }) {
	if (e && t) return k({
		from: new Date(e),
		to: new Date(t)
	});
	if (n && r) return k({
		from: new Date(n),
		to: new Date(r)
	});
}
//#endregion
//#region src/components/ReactPdfCreditNote/LineItems/LineItems.tsx
var dn = ({ creditNote: e, lineItemGroups: t, lineItems: n, refTotalsPage: r, alwaysShowServicePeriods: i }) => {
	let { currency: a } = e, o = (t) => {
		if (i) return un({
			start: t.servicePeriodStart,
			end: t.servicePeriodEnd,
			fallbackStart: e.billingPeriodStart,
			fallbackEnd: e.billingPeriodEnd
		});
	}, s = n.filter((e) => !e.groupId), c = s.reduce((e, t) => e + Number(t.netTotal), 0).toString(), l = an({
		lineItems: s,
		currency: a
	});
	return /* @__PURE__ */ w(D, {
		style: { gap: 12 },
		children: [
			s.length > 0 && /* @__PURE__ */ w(Kt, { children: [
				/* @__PURE__ */ C(pn, { columnWidths: l }),
				s.map((t) => /* @__PURE__ */ C(cn, {
					lineItem: t,
					creditNote: e,
					columnWidths: l,
					servicePeriod: o(t)
				}, t.id)),
				/* @__PURE__ */ C(hn, { subtotal: x({
					currency: a,
					value: c
				}) })
			] }),
			t.map((t) => {
				let r = n.filter((e) => e.groupId === t.id), i = an({
					lineItems: r,
					currency: a
				});
				return /* @__PURE__ */ w(Kt, {
					primaryText: t.title,
					children: [
						/* @__PURE__ */ C(pn, { columnWidths: i }),
						r.map((t) => /* @__PURE__ */ C(cn, {
							lineItem: t,
							creditNote: e,
							columnWidths: i,
							servicePeriod: o(t)
						}, t.id)),
						/* @__PURE__ */ C(hn, { subtotal: x({
							currency: a,
							value: t.netTotal
						}) })
					]
				}, t.id);
			}),
			/* @__PURE__ */ C(Et, {
				creditNote: e,
				refTotalsPage: r
			})
		]
	});
}, { lato12RegularGreyGrey60: fn } = I, pn = ({ columnWidths: e }) => /* @__PURE__ */ C(Yt, {
	borderBottom: ee,
	children: Object.keys(B).map((t, n) => {
		let r = B[t];
		return /* @__PURE__ */ C(z, {
			value: r.value,
			width: n === 0 ? r.width : rn({
				minWidth: r.width,
				width: e[t]
			}),
			paddingLeft: r.paddingLeft,
			paddingRight: r.paddingRight,
			textAlign: r.textAlign,
			fontStyle: fn
		}, r.value);
	})
}), { lato12BoldGreyGrey100: mn } = I, hn = ({ subtotal: e }) => /* @__PURE__ */ w(Yt, { children: [/* @__PURE__ */ C(z, {
	value: "Subtotal",
	paddingLeft: 0,
	textAlign: "left",
	fontStyle: mn
}), /* @__PURE__ */ C(z, {
	value: e,
	fontStyle: mn,
	paddingRight: 0
})] }), { page: gn, wrapper: _n } = I, vn = ({ accent: e, header: t, footerString: n, refTotalsPage: r, watermarks: i, children: a, style: o = {} }) => /* @__PURE__ */ w(Pe, {
	size: "A4",
	dpi: 72,
	style: gn,
	wrap: !0,
	children: [
		e,
		/* @__PURE__ */ w(D, {
			style: {
				..._n,
				...o
			},
			children: [t, a]
		}),
		/* @__PURE__ */ C(Bt, {
			refTotalsPage: r,
			text: n
		}),
		i
	]
}), { watermark: yn, watermarkText: bn } = I, xn = ({ text: e }) => /* @__PURE__ */ C(D, {
	style: yn,
	fixed: !0,
	children: /* @__PURE__ */ C(E, {
		style: bn,
		children: e
	})
}), Sn = ({ entity: e, showNonProdWatermark: t }) => /* @__PURE__ */ w(S, { children: [
	e.status === "DRAFT" && /* @__PURE__ */ C(xn, { text: "Draft" }),
	e.status === "VOIDED" && /* @__PURE__ */ C(xn, { text: "Void" }),
	t && /* @__PURE__ */ C(xn, { text: "Test" })
] });
//#endregion
//#region src/components/ReactPdfCreditNote/ReactPdfCreditNote.tsx
Oe();
var Cn = ({ creditNote: e, lineItems: t, lineItemGroups: n, merchantDetails: r, showNonProdWatermark: i, isRenderedInBrowser: a, alwaysShowServicePeriods: o }) => {
	let s = /* @__PURE__ */ C(It, { merchantDetails: r }), c = We();
	return /* @__PURE__ */ C(je, { children: /* @__PURE__ */ C(vn, {
		accent: s,
		footerString: `${dt(e.creditNoteNumber)} — ${x({
			currency: e.currency,
			value: e.grossTotal,
			appendCurrencyCode: !0
		})}`,
		refTotalsPage: c,
		watermarks: /* @__PURE__ */ C(Sn, {
			entity: e,
			showNonProdWatermark: i
		}),
		children: /* @__PURE__ */ w(D, {
			style: { marginTop: -8 },
			children: [
				/* @__PURE__ */ C(Nt, {
					merchantDetails: r,
					isRenderedInBrowser: a
				}),
				/* @__PURE__ */ C(bt, {
					creditNote: e,
					merchantDetails: r
				}),
				/* @__PURE__ */ C(ut, { creditNote: e }),
				/* @__PURE__ */ C(dn, {
					creditNote: e,
					lineItems: t,
					lineItemGroups: n,
					refTotalsPage: c,
					alwaysShowServicePeriods: o
				})
			]
		})
	}) });
}, wn = {
	billingPeriodTextColor: f,
	groupSummaryLineTextLeftColor: te,
	groupSummaryLineTextRightColor: f,
	separatorBorderColor: u,
	grossTotalTextColor: f
}, V = (e, t) => t?.[e] ?? wn[e], Tn = ({ description: e, amount: t, styles: n }) => /* @__PURE__ */ w(o, {
	justify: "space-between",
	children: [/* @__PURE__ */ C(_, {
		...h,
		color: V("groupSummaryLineTextLeftColor", n),
		children: e
	}), /* @__PURE__ */ C(_, {
		...h,
		color: V("groupSummaryLineTextRightColor", n),
		children: t
	})]
}), En = ({ billingPeriod: e, groupSummary: t, totals: n, styles: r }) => {
	let i = !!e, a = !!t.length, c = i || a;
	return /* @__PURE__ */ w(o, {
		backgroundColor: s,
		borderRadius: "8px",
		direction: "column",
		gap: "16px",
		padding: "16px",
		children: [
			i && /* @__PURE__ */ C(_, {
				...me,
				color: V("billingPeriodTextColor", r),
				children: e
			}),
			a && /* @__PURE__ */ C(o, {
				flexDirection: "column",
				gap: "12px",
				children: t.map(({ description: e, total: t }, n) => /* @__PURE__ */ C(Tn, {
					description: e,
					amount: t,
					styles: r
				}, n))
			}),
			/* @__PURE__ */ w(o, {
				flexDirection: "column",
				gap: "12px",
				children: [/* @__PURE__ */ w(o, {
					flexDirection: "column",
					gap: "12px",
					paddingTop: c ? "12px" : "0px",
					paddingBottom: "12px",
					borderTop: c ? `${V("separatorBorderColor", r)} 1px solid` : "none",
					borderBottom: `${V("separatorBorderColor", r)} 1px solid`,
					children: [/* @__PURE__ */ C(Tn, {
						description: "Subtotal",
						amount: n.netTotal,
						styles: r
					}), /* @__PURE__ */ C(Tn, {
						description: n.taxLabel,
						amount: n.totalTax,
						styles: r
					})]
				}), /* @__PURE__ */ w(o, {
					justify: "space-between",
					align: "center",
					children: [/* @__PURE__ */ C(_, {
						...me,
						color: V("grossTotalTextColor", r),
						children: "Total"
					}), /* @__PURE__ */ C(_, {
						...he,
						color: V("grossTotalTextColor", r),
						children: n.grossTotal
					})]
				})]
			})
		]
	});
}, Dn = (e) => {
	let t = {
		description: b("IBAN"),
		fields: [{
			label: "Account name",
			value: e.legalCompanyName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [...t.fields, {
			label: "IBAN",
			value: e.iban
		}]
	};
}, On = (e) => {
	let t = {
		description: b("UK_BANK_ACCOUNT"),
		fields: [{
			label: "Account name",
			value: e.legalCompanyName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.ukAccountDetails.accountNumber
			},
			{
				label: "Sort code",
				value: Ee({ sortCode: e.ukAccountDetails.sortCode })
			}
		]
	};
}, kn = (e) => {
	let t = {
		description: b("US_ACH"),
		fields: [{
			label: "Account name",
			value: e.usAchDetails.accountName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.usAchDetails.accountNumber
			},
			{
				label: "Bank name",
				value: e.usAchDetails.bankName
			},
			{
				label: "Bank routing number",
				value: e.usAchDetails.bankRoutingNumber
			}
		]
	};
}, An = (e) => {
	let t = {
		description: b("US_WIRE"),
		fields: [{
			label: "Account name",
			value: e.usWireDetails.accountName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.usWireDetails.accountNumber
			},
			{
				label: "Bank name",
				value: e.usWireDetails.bankName
			},
			{
				label: "Bank routing number",
				value: e.usWireDetails.bankRoutingNumber
			},
			{
				label: "SWIFT code",
				value: e.usWireDetails.swiftCode
			},
			{
				label: "Bank address",
				value: v(e.usWireDetails.bankAddress).join(", ")
			}
		]
	};
}, jn = (e) => {
	let t = {
		description: b("CA_BANK_ACCOUNT"),
		fields: [{
			label: "Account name",
			value: e.legalCompanyName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.caBankAccountDetails.accountNumber
			},
			{
				label: "Transit number",
				value: e.caBankAccountDetails.transitNumber
			},
			{
				label: "Institution number",
				value: e.caBankAccountDetails.institutionNumber
			}
		]
	};
}, Mn = (e) => {
	let t = {
		description: b("CA_INTERNATIONAL"),
		fields: [{
			label: "Legal name",
			value: e.canadianInternationalDestination.legalName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	if (t.fields = [
		...t.fields,
		{
			label: "Account number",
			value: e.canadianInternationalDestination.accountNumber
		},
		{
			label: "Transit number",
			value: e.canadianInternationalDestination.transitNumber
		},
		{
			label: "Bank name",
			value: e.canadianInternationalDestination.bankName
		},
		{
			label: "Bank address",
			value: v(e.canadianInternationalDestination.bankAddress).join(", ")
		},
		{
			label: "Institution number",
			value: e.canadianInternationalDestination.institutionNumber ?? ""
		},
		{
			label: "SWIFT code",
			value: e.canadianInternationalDestination.swiftCode
		}
	], e.canadianInternationalDestination.intermediaryBank) {
		let n = [
			{
				label: "Intermediary bank name",
				value: e.canadianInternationalDestination.intermediaryBank.bankName
			},
			{
				label: "Intermediary bank address",
				value: v(e.canadianInternationalDestination.intermediaryBank.bankAddress).join(", ")
			},
			{
				label: "Intermediary bank routing number",
				value: e.canadianInternationalDestination.intermediaryBank.routingNumber
			},
			{
				label: "Intermediary SWIFT code",
				value: e.canadianInternationalDestination.intermediaryBank.swiftCode
			}
		];
		t.fields = [...t.fields, ...n];
	}
	return t;
}, Nn = (e) => {
	let t = {
		description: b("AUSTRALIAN"),
		fields: [{
			label: "Legal name",
			value: e.australianDestination.legalName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return t.fields = [
		...t.fields,
		{
			label: "Account number",
			value: e.australianDestination.accountNumber
		},
		{
			label: "BSB",
			value: e.australianDestination.bsb
		},
		{
			label: "SWIFT code",
			value: e.australianDestination.swiftCode
		}
	], t;
}, Pn = (e) => {
	let t = {
		description: b("SWEDISH_BANKGIRO"),
		fields: [{
			label: "Account name",
			value: e.swedishBankgiro.accountName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = v(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return t.fields = [...t.fields, {
		label: "Bankgiro number",
		value: e.swedishBankgiro.bankgiroNumber
	}], t;
}, Fn = (e) => "usAchDetails" in e || "usWireDetails" in e || "caBankAccountDetails" in e, In = (e) => "usAchDestination" in e || "usWireDestination" in e || "caBankAccountDestination" in e, Ln = (e) => {
	let t = [];
	if (e.iban) {
		let n = e.iban;
		t.push(Dn({
			...e,
			iban: n
		}));
	}
	if (e.ukAccountDetails) {
		let n = e.ukAccountDetails;
		t.push(On({
			...e,
			ukAccountDetails: n
		}));
	}
	if (e.australianDestination) {
		let n = e.australianDestination;
		t.push(Nn({
			...e,
			australianDestination: n
		}));
	}
	if (e.swedishBankgiro) {
		let n = e.swedishBankgiro;
		t.push(Pn({
			...e,
			swedishBankgiro: n
		}));
	}
	if (e.canadianInternationalDestination) {
		let n = e.canadianInternationalDestination;
		t.push(Mn({
			...e,
			canadianInternationalDestination: n
		}));
	}
	if (Fn(e) && e.usAchDetails) {
		let n = e.usAchDetails;
		t.push(kn({
			...e,
			usAchDetails: n
		}));
	}
	if (In(e) && e.usAchDestination) {
		let n = e.usAchDestination;
		t.push(kn({
			...e,
			usAchDetails: n
		}));
	}
	if (Fn(e) && e.usWireDetails) {
		let n = e.usWireDetails;
		t.push(An({
			...e,
			usWireDetails: n
		}));
	}
	if (In(e) && e.usWireDestination) {
		let n = e.usWireDestination;
		t.push(An({
			...e,
			usWireDetails: n
		}));
	}
	if (Fn(e) && e.caBankAccountDetails) {
		let n = e.caBankAccountDetails;
		t.push(jn({
			...e,
			caBankAccountDetails: n
		}));
	}
	if (In(e) && e.caBankAccountDestination) {
		let n = e.caBankAccountDestination;
		t.push(jn({
			...e,
			caBankAccountDetails: n
		}));
	}
	return t;
}, Rn = {
	...fe,
	color: d,
	pr: "24px",
	py: "10px",
	textTransform: "uppercase",
	width: "fit-content"
}, zn = {
	...fe,
	color: d,
	width: "fit-content",
	whiteSpace: "nowrap",
	textAlign: "right",
	px: "12px",
	py: "10px",
	textTransform: "uppercase"
}, Bn = {
	pr: "48px",
	py: "10px",
	...h,
	color: d,
	width: "fit-content"
}, Vn = {
	width: "fit-content",
	whiteSpace: "nowrap",
	textAlign: "right",
	px: "12px",
	py: "10px",
	...h,
	color: d
}, Hn = (e) => e.usageBreakdown.length ? /* @__PURE__ */ w(o, {
	padding: "16px 24px 24px",
	background: ne,
	boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 4px 0px rgba(0, 0, 0, 0.02)",
	borderRadius: "8px",
	border: `${u} 1px solid`,
	flexDirection: "column",
	children: [/* @__PURE__ */ C(o, {
		...me,
		minHeight: "36px",
		width: "100%",
		alignItems: "center",
		justifyContent: "space-between",
		children: "Usage overview"
	}), /* @__PURE__ */ w(ve, {
		variant: "lineItemGroup",
		width: "100%",
		children: [/* @__PURE__ */ C(be, { children: /* @__PURE__ */ w(Se, { children: [
			/* @__PURE__ */ C(g, {
				...Rn,
				children: "Sub account"
			}),
			/* @__PURE__ */ C(g, {
				...Rn,
				children: "Metric"
			}),
			/* @__PURE__ */ C(g, {
				...zn,
				children: "qty"
			})
		] }) }), /* @__PURE__ */ C(ye, { children: e.usageBreakdown.map((e) => e.usageData.map((t, n) => /* @__PURE__ */ w(Se, { children: [
			/* @__PURE__ */ C(g, {
				...Bn,
				children: !n && e.subAccountLabel
			}),
			/* @__PURE__ */ C(g, {
				...Bn,
				children: t.label
			}),
			/* @__PURE__ */ C(g, {
				...Vn,
				children: t.quantity
			})
		] }, `${e.subAccountLabel}${t.label}`))) })]
	})]
}) : null, Un = ({ isOpen: e, onClose: r, detailItems: i, merchantLegalCompanyName: s, secondaryButton: c }) => /* @__PURE__ */ w(ue, {
	isOpen: e,
	onClose: r,
	width: {
		base: "calc(100svw - 32px)",
		sm: "480px"
	},
	"data-testid": "modal.payment-details",
	children: [
		/* @__PURE__ */ C(ue.Header, {
			withBorder: !0,
			children: "Payment details"
		}),
		/* @__PURE__ */ C(ue.Content, {
			maxHeight: "80svh",
			children: /* @__PURE__ */ w(o, {
				direction: "column",
				children: [
					s && /* @__PURE__ */ C(t, { children: /* @__PURE__ */ w(_, {
						...h,
						color: te,
						"data-testid": "modal.payment-details.merchantInstruction",
						children: ["Use the details below to pay ", s]
					}) }),
					i.map((e) => /* @__PURE__ */ w(o, {
						direction: "column",
						justifyContent: "center",
						paddingY: "8px",
						_first: { paddingTop: "0px" },
						"data-testid": `modal.payment-details.section.${e.description}`,
						children: [/* @__PURE__ */ C(o, {
							minHeight: "32px",
							alignItems: "center",
							children: /* @__PURE__ */ C(_, {
								...pe,
								color: f,
								children: e.description
							})
						}), /* @__PURE__ */ C(o, {
							direction: "column",
							css: { "&:has([data-payment-details-value]:hover) > div:not(:hover)": { opacity: .6 } },
							children: e.fields.map((e) => /* @__PURE__ */ w(p, {
								gap: "16px",
								gridTemplateColumns: "140px 1fr",
								transition: "opacity 150ms ease",
								sx: {
									".pdd-row:hover .pdd-row-copy": { display: "block" },
									".pdd-row-copy svg": {
										height: "12px",
										width: "12px"
									}
								},
								children: [/* @__PURE__ */ C(_, {
									py: "4px",
									...h,
									color: d,
									children: e.label
								}), /* @__PURE__ */ C(o, {
									gap: "4px",
									className: "pdd-row",
									"data-testid": `modal.payment-details.field.${e.label}`,
									children: /* @__PURE__ */ C(Wn, { value: e.lines })
								})]
							}, e.label))
						})]
					}, e.description)),
					i.length === 0 && /* @__PURE__ */ C(a, {
						title: "No payment details",
						body: "Add details for different currencies such as ACH, Wire or\n                  regular bank transfers.",
						icon: re,
						iconSize: "md"
					})
				]
			})
		}),
		/* @__PURE__ */ w(ue.Footer, {
			withBorder: !0,
			justifyContent: c ? "space-between" : "flex-end",
			children: [c && /* @__PURE__ */ C(n, {
				variant: "secondary",
				type: "button",
				onClick: () => {
					c.onClick();
				},
				children: c.text
			}), /* @__PURE__ */ C(n, {
				variant: "primary",
				type: "button",
				"data-testid": "modal.payment-details.done",
				onClick: () => {
					r();
				},
				children: "Done"
			})]
		})
	]
}), Wn = ({ value: e }) => {
	let [t, r] = Ge(!1), i = (e) => {
		navigator.clipboard.writeText(e), r(!0), setTimeout(() => {
			r(!1);
		}, 1500);
	};
	return /* @__PURE__ */ C(xe, {
		hasArrow: !0,
		placement: "top",
		closeOnClick: !1,
		label: t ? "Copied" : "Click to copy",
		children: /* @__PURE__ */ C(n, {
			"data-payment-details-value": !0,
			variant: "unstyled",
			as: "span",
			...h,
			color: te,
			className: "group",
			onClick: () => i(e.join(", ")),
			children: /* @__PURE__ */ C(_, {
				as: "span",
				color: te,
				py: "4px",
				...h,
				fontWeight: "semibold",
				wordBreak: "break-word",
				whiteSpace: "pre-wrap",
				_groupHover: { textDecoration: "underline" },
				children: e.map((t, n) => /* @__PURE__ */ w(S, { children: [t, n < e.length - 1 && /* @__PURE__ */ C("br", {})] }))
			})
		})
	});
}, Gn = (e) => {
	let t = {
		borderBottom: e.hideBorder ? void 0 : `${u} 1px solid`,
		display: "flex",
		alignItems: "flex-start"
	};
	return /* @__PURE__ */ w(p, {
		className: "group",
		gridTemplateColumns: `266fr 60fr 76fr 44fr 144fr ${e.action ? "32px" : "0px"}`,
		background: ne,
		_hover: e.onClick ? { background: s } : {},
		position: "relative",
		opacity: e.unsynced ? .5 : 1,
		onClick: e.onClick,
		cursor: e.onClick ? "pointer" : "default",
		style: e.style,
		children: [
			e.dragHandle,
			/* @__PURE__ */ C(m, {
				...t,
				children: e.name
			}),
			/* @__PURE__ */ C(m, {
				...t,
				children: e.qty
			}),
			/* @__PURE__ */ C(m, {
				...t,
				justifyContent: "flex-end",
				children: e.rate
			}),
			/* @__PURE__ */ C(m, {
				...t,
				justifyContent: "flex-end",
				children: e.tax
			}),
			/* @__PURE__ */ C(m, {
				...t,
				justifyContent: "flex-end",
				gridColumn: e.action ? void 0 : "span 2",
				children: e.amount
			}),
			e.action ? e.unsynced ? /* @__PURE__ */ C(r, { children: /* @__PURE__ */ C(_e, {
				width: "16px",
				height: "16px",
				color: u
			}) }) : /* @__PURE__ */ C(m, {
				...t,
				alignItems: "center",
				children: e.action
			}) : null
		]
	});
}, H = Object.assign(({ value: e, otherRows: t, strong: n = !1, indentation: r = 0, "data-testid": i }) => /* @__PURE__ */ w(o, {
	flexDir: "column",
	paddingY: "8px",
	paddingLeft: `${r * 4 + 4}px`,
	gap: "8px",
	children: [/* @__PURE__ */ C(_, {
		...h,
		fontWeight: n ? "semibold" : "normal",
		color: f,
		"data-testid": i,
		children: e
	}), t?.map((e, t) => /* @__PURE__ */ C(_, {
		...h,
		color: d,
		whiteSpace: "pre-line",
		children: e
	}, t))]
}), {
	Header: ({ value: e }) => /* @__PURE__ */ C(_, {
		...de,
		color: d,
		paddingY: "8px",
		children: e
	}),
	Skeleton: () => /* @__PURE__ */ C(t, {
		width: "70%",
		height: "8px",
		borderRadius: "8px",
		background: l,
		alignSelf: "center"
	}),
	KebabMenu: ({ items: e }) => {
		let [t, n] = Ge(!1);
		return /* @__PURE__ */ C(r, {
			boxSize: "32px",
			opacity: t ? "1" : "0",
			_groupHover: { opacity: 1 },
			children: /* @__PURE__ */ C(ge, {
				variant: "ghost",
				buttonSize: "small",
				items: e,
				onOpenChange: n
			})
		});
	}
}), Kn = Object.assign(({ children: e }) => /* @__PURE__ */ C(o, {
	flexDir: "column",
	width: "100%",
	children: e
}), {
	Row: Gn,
	Cell: H,
	Header: ({ showActionColumn: e = !0 }) => /* @__PURE__ */ C(Gn, {
		name: /* @__PURE__ */ C(H.Header, { value: "Name" }),
		qty: /* @__PURE__ */ C(H.Header, { value: "Qty" }),
		rate: /* @__PURE__ */ C(H.Header, { value: "Rate" }),
		tax: /* @__PURE__ */ C(H.Header, { value: "Tax" }),
		amount: /* @__PURE__ */ C(H.Header, { value: "Amount" }),
		action: e || void 0
	})
}), qn = {
	fontFamily: "Lato",
	fontSize: "32px",
	lineHeight: 1.25,
	fontWeight: 600
}, Jn = {
	fontFamily: "Lato",
	fontSize: "24px",
	lineHeight: 1.25,
	fontWeight: 600
}, Yn = {
	fontFamily: "Lato",
	fontSize: "12px",
	lineHeight: 1.41666,
	fontWeight: 600
}, Xn = {
	fontFamily: "Lato",
	fontSize: "18px",
	lineHeight: 1,
	fontWeight: 600
}, Zn = {
	fontFamily: "Lato",
	fontSize: "12px",
	lineHeight: 1.41666,
	fontWeight: 400
}, U = {
	fontFamily: "Lato",
	fontSize: "11px",
	lineHeight: 1.36363,
	fontWeight: 600
}, W = {
	fontFamily: "Lato",
	fontSize: "11px",
	lineHeight: 1.36363,
	fontWeight: 400
}, Qn = { DEFAULT: {
	page: { padding: "32px" },
	gridSystem: {
		columns: 16,
		columnGap: "16px"
	},
	mainPage: { gap: "32px" },
	header: {
		container: { gap: "16px" },
		total: {
			container: { gap: "4px" },
			text: {
				...qn,
				color: "#333333"
			},
			alternativeText: {
				...Jn,
				color: "#333333"
			}
		},
		invoiceTitle: {
			...Xn,
			color: "#333333"
		},
		dueDatePayOnline: {
			container: { gap: "8px" },
			dueDateText: {
				...Yn,
				color: "#333333"
			},
			urlPayOnlineText: {
				...Yn,
				color: ae,
				textDecoration: "none"
			}
		},
		merchantName: {
			...Jn,
			color: "#1F1F1f",
			textAlign: "right"
		},
		logo: { height: "32px" }
	},
	contactDetails: {
		title: {
			...U,
			color: "#333333",
			marginBottom: "4px"
		},
		body: {
			...W,
			color: "#333333"
		}
	},
	summary: {
		containerTerms: { gap: "4px" },
		header: {
			...U,
			color: "#333333",
			marginBottom: "4px"
		},
		label: {
			container: { width: "90px" },
			text: {
				...W,
				color: "#666666"
			}
		},
		value: {
			...W,
			color: "#333333"
		},
		valueLink: {
			...W,
			color: ae,
			textDecoration: "none"
		}
	},
	lineItems: { container: { gap: "24px" } },
	lineItemTable: {
		header: {
			row: {
				borderBottomWidth: "1px",
				borderBottomColor: "#E5E5E5",
				paddingTop: "8px",
				paddingBottom: "8px"
			},
			cellText: {
				...U,
				color: "#333333"
			}
		},
		body: {
			row: {
				borderBottomWidth: "1px",
				borderBottomColor: "#E5E5E5",
				paddingTop: "8px",
				paddingBottom: "8px"
			},
			rowIndentation: { paddingLeft: "8px" },
			cellContainer: { gap: "4px" },
			cellTextBase: {
				...W,
				color: "#333333"
			},
			cellTextSecondary: { color: "#808080" },
			cellTextCaption: {
				...W,
				color: "#808080"
			},
			cellTextNameFirstLevel: {
				...U,
				color: "#333333"
			},
			cellTextNameSecondLevel: {
				...W,
				color: "#333333"
			}
		}
	},
	totals: {
		container: { gap: "8px" },
		labelLink: {
			...W,
			color: ae,
			textDecoration: "none"
		},
		default: {
			text: {
				...W,
				color: "#666666"
			},
			row: {
				paddingTop: "0px",
				paddingBottom: "0px"
			}
		},
		total: {
			text: {
				...W,
				color: "#666666"
			},
			row: {
				borderTopColor: "#E5E5E5",
				borderTopWidth: "1px",
				paddingTop: "0px",
				paddingBottom: "0px"
			}
		},
		grandTotal: {
			text: {
				...U,
				color: "#333333"
			},
			row: {
				borderTopColor: "#666666",
				borderTopWidth: "1px",
				paddingTop: "8px",
				paddingBottom: "0px"
			}
		}
	},
	totalsCaptions: {
		container: {
			gap: "4px",
			marginTop: "16px"
		},
		text: {
			...W,
			color: "#666666",
			textAlign: "right"
		}
	},
	footer: {
		summary: {
			...W,
			color: "#333333"
		},
		total: {
			...W,
			color: "#333333"
		},
		container: {
			paddingTop: "16px",
			borderTopColor: "#E5E5E5",
			borderTopWidth: "1px"
		}
	},
	poweredBy: {
		text: {
			...Zn,
			color: f,
			textDecoration: "none"
		},
		logo: {
			width: "64px",
			height: "16px"
		}
	},
	detailsBlock: {
		container: { gap: "16px" },
		header: {
			container: { gap: "8px" },
			title: {
				...U,
				color: f
			},
			subtitle: {
				...W,
				color: "#666666"
			}
		},
		group: {
			container: {
				default: { gap: "4px" },
				lg: { gap: "8px" }
			},
			title: {
				...U,
				color: f
			}
		},
		item: {
			title: {
				...W,
				color: "#666666"
			},
			values: {
				container: { gap: "1px" },
				text: {
					...W,
					color: f
				}
			}
		}
	},
	watermark: { text: {
		fontFamily: "Lato",
		fontWeight: 600,
		fontSize: "144px",
		lineHeight: 1.2,
		color: "rgba(0, 0, 0, 0.3)",
		transform: "rotate(-45deg)",
		textAlign: "center"
	} },
	currencyConversion: { exchangeRate: {
		container: { gap: "8px" },
		icon: {
			boxSize: "16px",
			fill: f
		}
	} }
} }, $n = A("DEFAULT"), G = A((e) => Qn[e($n)]), er = .875, K = A((e) => tr(e(G))), tr = (e) => {
	if (typeof e == "string") return e.endsWith("px") ? `${parseInt(e, 10) * er}px` : e;
	if (typeof e == "object") {
		let t = {};
		for (let n in e) Object.hasOwn(e, n) && (t[n] = tr(e[n]));
		return t;
	}
	return e;
}, nr = "d LLLL yyyy", q = {
	REVERSE_CHARGED: "Reverse charge applies",
	AUTO_CHARGED: "You may be charged automatically for this invoice",
	TAX_ID_PREFIX: "Tax ID:"
}, rr = ({ quantity: e, rateDisplay: t, currency: n }) => O(t).with("ABSOLUTE", () => we()(e)).with("PERCENTAGE", () => x({
	currency: n,
	value: e
})).exhaustive(), ir = ({ rate: e, rateDisplay: t, currency: n }) => e === "VARIES" ? "Varies" : O(t).with("ABSOLUTE", () => x({
	currency: n,
	value: e,
	maximumFractionDigits: 10
})).with("PERCENTAGE", () => Ae(De(e))).exhaustive(), ar = ({ taxRate: e }) => Ae(Te(De(e), 2)), or = ({ netTotal: e, currency: t }) => x({
	currency: t,
	value: e
}), sr = ({ lineItemGroups: e, currency: t }) => ({ taxRows: cr({
	allLineItems: e.flatMap((e) => e.lineItems),
	currency: t
}) }), cr = ({ allLineItems: e, currency: t }) => {
	let n = Array.from([...new Set(e.map((e) => e.taxRate))]).sort((e, t) => new M(e).minus(new M(t)).toNumber()), r = n.length === 1 && n[0] === "0";
	return e.length === 0 || r ? [["Tax", "0"]] : n.map((n) => {
		let r = e.filter((e) => e.taxRate === n), i = r.reduce((e, t) => e.plus(new M(t.netTotal)), new M(0)).toString(), a = r.reduce((e, t) => e.plus(new M(t.totalTax)), new M(0)).toString();
		return [`Tax (${ar({ taxRate: n })} on ${x({
			value: i,
			currency: t
		})})`, a];
	});
}, J = (e) => e.includeBeneficiaryAddressInPaymentDetails ? [{
	label: "Address",
	lines: v(e.address)
}] : [], lr = (e) => [{
	description: "Bank transfer",
	fields: [
		{
			label: "Account name",
			lines: [e.legalCompanyName]
		},
		...J(e),
		{
			label: "IBAN",
			lines: [e.iban]
		}
	]
}], ur = (e) => "iban" in e, dr = (e) => [{
	description: "UK bank transfer",
	fields: [
		{
			label: "Account name",
			lines: [e.legalCompanyName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.ukAccountDetails.accountNumber]
		},
		{
			label: "Sort code",
			lines: [Ee({ sortCode: e.ukAccountDetails.sortCode })]
		}
	]
}], fr = (e) => "ukAccountDetails" in e, pr = (e) => [{
	description: "Australian bank transfer",
	fields: [
		{
			label: "Legal name",
			lines: [e.australianDestination.legalName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.australianDestination.accountNumber]
		},
		{
			label: "BSB",
			lines: [e.australianDestination.bsb]
		},
		{
			label: "Swift code",
			lines: [e.australianDestination.swiftCode]
		}
	]
}], mr = (e) => "australianDestination" in e, hr = (e) => [{
	description: "Swedish bankgiro",
	fields: [
		{
			label: "Account name",
			lines: [e.swedishBankgiroDestination.accountName]
		},
		...J(e),
		{
			label: "Bankgiro number",
			lines: [e.swedishBankgiroDestination.bankgiroNumber]
		}
	]
}], gr = (e) => "swedishBankgiroDestination" in e, _r = (e) => [{
	description: "ACH",
	fields: [
		{
			label: "Account name",
			lines: [e.usAchDetails.accountName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.usAchDetails.accountNumber]
		},
		{
			label: "Bank name",
			lines: [e.usAchDetails.bankName]
		},
		{
			label: "Bank routing number",
			lines: [e.usAchDetails.bankRoutingNumber]
		}
	]
}], vr = (e) => "usAchDetails" in e, yr = (e) => "usAchDestination" in e, br = (e) => {
	let t = e.canadianInternationalDestination.intermediaryBank;
	return [
		{
			description: "Canadian international bank transfer",
			fields: []
		},
		{
			description: "Beneficiary",
			fields: [
				{
					label: "Legal name",
					lines: [e.canadianInternationalDestination.legalName]
				},
				...J(e),
				{
					label: "Account number",
					lines: [e.canadianInternationalDestination.accountNumber]
				},
				{
					label: "Transit number",
					lines: [e.canadianInternationalDestination.transitNumber]
				}
			]
		},
		{
			description: "Beneficiary bank",
			fields: [
				{
					label: "Bank name",
					lines: [e.canadianInternationalDestination.bankName]
				},
				{
					label: "Bank address",
					lines: v(e.canadianInternationalDestination.bankAddress)
				},
				{
					label: "Institution number",
					lines: [e.canadianInternationalDestination.institutionNumber]
				},
				{
					label: "Swift code",
					lines: [e.canadianInternationalDestination.swiftCode]
				}
			]
		},
		...t ? [{
			description: "Intermediary bank",
			fields: [
				{
					label: "Bank name",
					lines: [t.bankName]
				},
				{
					label: "Bank address",
					lines: v(t.bankAddress)
				},
				{
					label: "Routing number",
					lines: [t.routingNumber]
				},
				{
					label: "Swift code",
					lines: [t.swiftCode]
				}
			]
		}] : []
	];
}, xr = (e) => "canadianInternationalDestination" in e, Sr = (e) => [{
	description: "Wire",
	fields: [
		{
			label: "Account name",
			lines: [e.usWireDetails.accountName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.usWireDetails.accountNumber]
		},
		{
			label: "Bank name",
			lines: [e.usWireDetails.bankName]
		},
		{
			label: "Bank routing number",
			lines: [e.usWireDetails.bankRoutingNumber]
		},
		{
			label: "Swift code",
			lines: [e.usWireDetails.swiftCode]
		},
		{
			label: "Bank address",
			lines: v(e.usWireDetails.bankAddress)
		}
	]
}], Cr = (e) => "usWireDetails" in e, wr = (e) => "usWireDestination" in e, Tr = (e) => [{
	description: "Canadian bank transfer",
	fields: [
		{
			label: "Account name",
			lines: [e.legalCompanyName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.caBankAccountDetails.accountNumber]
		},
		{
			label: "Transit number",
			lines: [e.caBankAccountDetails.transitNumber]
		},
		{
			label: "Institution number",
			lines: [e.caBankAccountDetails.institutionNumber]
		}
	]
}], Er = (e) => "caBankAccountDetails" in e, Dr = (e) => "caBankAccountDestination" in e, Or = (e) => {
	let t = [];
	return ur(e) && t.push(...lr(e)), fr(e) && t.push(...dr(e)), mr(e) && t.push(...pr(e)), gr(e) && t.push(...hr(e)), xr(e) && t.push(...br(e)), vr(e) && t.push(..._r(e)), yr(e) && t.push(..._r({
		...e,
		usAchDetails: e.usAchDestination
	})), Cr(e) && t.push(...Sr(e)), wr(e) && t.push(...Sr({
		...e,
		usWireDetails: e.usWireDestination
	})), Er(e) && t.push(...Tr(e)), Dr(e) && t.push(...Tr({
		...e,
		caBankAccountDetails: e.caBankAccountDestination
	})), t;
}, kr = (e) => {
	let t = e.reduce((e, t) => t.items.reduce((e, n) => n.value === "0" || !n.value ? e : {
		...e,
		[n.title]: {
			subAccountLabel: n.title,
			usageData: [...e[n.title]?.usageData ?? [], {
				label: t.title,
				quantity: n.value
			}]
		}
	}, e), {});
	return Object.values(t);
}, Ar = ({ invoiceBillingPeriod: e, groupLineItems: t }) => {
	if (t.length === 0) return {
		showForLineItemGroup: !0,
		showForLineItem: !0
	};
	let n = jr(t);
	if (!e) return {
		showForLineItemGroup: n,
		showForLineItem: !n
	};
	if (!n) return {
		showForLineItemGroup: !1,
		showForLineItem: !0
	};
	let r = t[0].servicePeriod;
	return r ? {
		showForLineItemGroup: !(e.start === r.startDate && e.endInclusive === r.endDate),
		showForLineItem: !1
	} : {
		showForLineItemGroup: !1,
		showForLineItem: !1
	};
}, jr = (e) => {
	if (e.length === 0) return !0;
	let t = e[0]?.servicePeriod;
	return e.every((e) => {
		let n = e.servicePeriod;
		return t === void 0 && n === void 0 ? !0 : t === void 0 || n === void 0 ? !1 : t.startDate === n.startDate && t.endDate === n.endDate;
	});
}, Mr = (e, t) => e.index - t.index;
function Nr(e) {
	if (e) return k({
		from: new Date(e.startDate),
		to: new Date(e.endDate)
	});
}
function Pr({ lineItemGroups: e, currency: t, invoiceBillingPeriod: n, alwaysShowServicePeriod: r = !1 }) {
	if (!e || !t) return [];
	let i = r ? Fr(n) : void 0;
	return e.sort(Mr).map((e) => {
		let a = e.lineItems.at(0)?.servicePeriod, o = jr(e.lineItems), { showForLineItemGroup: s, showForLineItem: c } = r ? {
			showForLineItemGroup: o,
			showForLineItem: !o
		} : Ar({
			invoiceBillingPeriod: n,
			groupLineItems: e.lineItems
		});
		return {
			id: e.id,
			name: e.title,
			description: e.description,
			servicePeriod: s ? Nr(a) ?? i : void 0,
			lineItems: e.lineItems.sort(Mr).map((e) => ({
				id: e.id,
				name: e.title,
				description: e.description,
				qty: rr({
					quantity: e.quantity,
					rateDisplay: e.rateDisplay,
					currency: t
				}),
				rate: ir({
					rate: e.rate,
					rateDisplay: e.rateDisplay,
					currency: t
				}),
				tax: ar({ taxRate: e.taxRate }),
				amount: or({
					netTotal: e.netTotal,
					currency: t
				}),
				servicePeriod: c ? Nr(e.servicePeriod) ?? i : void 0
			}))
		};
	});
}
function Fr(e) {
	if (e) return k({
		from: new Date(e.start),
		to: new Date(e.endInclusive)
	});
}
//#endregion
//#region src/utils/getInvoiceTitle/getInvoiceTitle.ts
var Ir = ({ customerCountry: e, customerTaxStatus: t }) => {
	if (e === "SG" && t === "TAXED") return "Tax invoice";
};
//#endregion
//#region src/utils/resolveServicePeriods.ts
function Lr({ lineItemGroups: e, billingPeriod: t, alwaysShow: n }) {
	let r = n ? Br(t) : void 0;
	return e.map((e) => {
		let i = e.lineItems.map((e) => ({ servicePeriod: e.servicePeriodStart && e.servicePeriodEnd ? {
			startDate: Rr(e.servicePeriodStart),
			endDate: Rr(e.servicePeriodEnd)
		} : void 0 })), a = jr(i), { showForLineItemGroup: o, showForLineItem: s } = n ? {
			showForLineItemGroup: a,
			showForLineItem: !a
		} : Ar({
			invoiceBillingPeriod: t,
			groupLineItems: i
		}), c = i.at(0)?.servicePeriod, l = o ? zr(c) ?? r : void 0, { lineItems: u, ...ee } = e;
		return {
			...ee,
			servicePeriod: l,
			lineItems: e.lineItems.map((e, t) => {
				let { servicePeriodStart: n, servicePeriodEnd: a, ...o } = e;
				return {
					...o,
					servicePeriod: s ? zr(i[t].servicePeriod) ?? r : void 0
				};
			})
		};
	});
}
function Rr(e) {
	return Re(ze(e));
}
function zr(e) {
	if (e) return k({
		from: new Date(e.startDate),
		to: new Date(e.endDate)
	});
}
function Br(e) {
	if (e) return k({
		from: new Date(e.start),
		to: new Date(e.endInclusive)
	});
}
//#endregion
//#region src/utils/settlement/settlement.ts
var Vr = "Credit note", Hr = 2, Ur = "Credit applied", Wr = (e) => e ? `${Ur} - ${e}` : Ur, Gr = ({ appliedAmount: e, grossTotal: t }) => e ?? t, Kr = (e = []) => ni(e.map(Gr)), qr = (e) => e.status === "APPLIED", Jr = (e) => {
	try {
		return new M(e ?? "0").abs().toString();
	} catch {
		return "0";
	}
}, Yr = (e) => {
	try {
		return new M(e ?? "0");
	} catch {
		return new M(0);
	}
}, Xr = (e) => Jr(e.amount), Zr = (e) => Jr(e.taxAmount), Qr = (e) => new M(Xr(e)).plus(Zr(e)).toString(), $r = ({ appliedGrants: e, appliedCreditGrantTax: t }) => t == null ? ni(e.map(Zr)) : Jr(t), ei = ({ appliedCreditGrants: e, appliedCreditGrantTax: t }) => {
	let n = e.filter(qr);
	return new M(ni(n.map(Xr))).plus($r({
		appliedGrants: n,
		appliedCreditGrantTax: t
	})).toString();
}, ti = ({ grossTotal: e, creditApplied: t, creditProjected: n = "0" }) => {
	let r = Yr(e), i = Yr(t).round(2).plus(Yr(n).round(2));
	if (i.eq(0)) return r.toFixed(2);
	let a = r.minus(i);
	return (a.lt(0) ? new M(0) : a).toFixed(2);
}, ni = (e) => e.reduce((e, t) => e.plus(t), new M(0)).toString(), ri = ({ appliedCreditNotes: e, appliedCreditGrants: t, appliedCreditGrantTax: n }) => {
	let r = t.filter(qr), i = ni(r.map(Xr)), a = $r({
		appliedGrants: r,
		appliedCreditGrantTax: n
	});
	return {
		net: i,
		tax: a,
		gross: ni([
			i,
			a,
			Kr(e)
		])
	};
}, ii = (...e) => {
	let t = e.filter(Boolean);
	return t.length > 0 ? t.join("\n") : void 0;
}, ai = ({ lineItemGroups: e, currency: t }) => e.sort((e, t) => e.index - t.index).flatMap((e) => [{
	name: {
		text: e.title,
		caption: ii(e.description, e.servicePeriod)
	},
	indentation: 0
}, ...e.lineItems.sort((e, t) => e.index - t.index).flatMap((e) => ({
	name: {
		text: e.title,
		caption: ii(e.description, e.servicePeriod)
	},
	quantity: { text: rr({
		quantity: e.quantity,
		rateDisplay: e.rateDisplay,
		currency: t
	}) },
	rate: { text: ir({
		rate: e.rate,
		rateDisplay: e.rateDisplay,
		currency: t
	}) },
	tax: { text: ar({ taxRate: e.taxRate }) },
	amount: { text: or({
		netTotal: e.netTotal,
		currency: t
	}) },
	indentation: 1
}))]), oi = ({ netTotal: e, grossTotal: t, currency: n, lineItemGroups: r, hasDeductions: i }) => {
	let { taxRows: a } = sr({
		lineItemGroups: r,
		currency: n
	});
	return [
		{
			label: "Subtotal",
			value: x({
				value: e,
				currency: n
			})
		},
		...a.map(([e, t]) => ({
			label: e,
			value: x({
				value: t,
				currency: n
			})
		})),
		{
			label: "Total",
			value: x({
				value: t,
				currency: n,
				appendCurrencyCode: !i
			}),
			variant: i ? "total" : "grandTotal"
		}
	];
}, si = ({ appliedCreditNotes: e, appliedCreditGrants: t, appliedCreditGrantTax: n, amountDue: r, currency: i }) => {
	let a = t.filter(qr);
	if (!(e.length + a.length > 0)) return [];
	let o = (e) => x({
		value: new M(e).times(-1).toString(),
		currency: i
	}), s = e.map((e, t) => ({
		label: e.creditNoteNumber || "Credit note",
		value: o(Gr(e)),
		href: e.url,
		testId: e.id ? `invoice.settlement.creditNote.${e.id}-${t}` : void 0
	})), c = a.map((e) => ({
		label: Wr(e.creditGrantName),
		value: o(Xr(e)),
		testId: e.creditGrantId ? `invoice.settlement.creditGrant.${e.creditGrantId}` : void 0
	})), l = ri({
		appliedCreditNotes: e,
		appliedCreditGrants: a,
		appliedCreditGrantTax: n
	}), u = c.length > 0 ? [{
		label: "Adjustment subtotal",
		value: o(l.net),
		variant: "total",
		testId: "invoice.settlement.adjustmentSubtotal"
	}, {
		label: "Tax",
		value: o(l.tax)
	}] : [];
	return [
		...ci(c),
		...u,
		...ci(s),
		{
			label: "Adjustment total",
			value: o(l.gross),
			variant: "total"
		},
		{
			label: "Total due",
			value: x({
				value: r,
				currency: i,
				appendCurrencyCode: !0
			}),
			variant: "grandTotal"
		}
	];
}, ci = (e) => e.map((e, t) => t === 0 ? {
	...e,
	variant: "total"
} : e), Y = A(), li = A((e) => {
	let t = e(Y);
	return t ? x({
		value: t.grossTotal,
		currency: t.currency,
		appendCurrencyCode: !0
	}) : "$0.00";
}), ui = A((e) => {
	let t = e(Y);
	return t ? x({
		value: t.amountDue,
		currency: t.currency,
		appendCurrencyCode: !0
	}) : "$0.00";
}), di = A((e) => {
	let t = e(Y);
	return t ? si({
		appliedCreditNotes: t.appliedCreditNotes ?? [],
		appliedCreditGrants: t.appliedCreditGrants ?? [],
		appliedCreditGrantTax: t.appliedCreditGrantTax,
		amountDue: t.amountDue,
		currency: t.currency
	}) : [];
}), fi = A((e) => e(di).length > 0), pi = A((e) => e(fi) ? e(ui) : e(li)), mi = A((e) => {
	let t = e(Y)?.dueDate;
	return t ? y(t, nr) : void 0;
}), hi = A((e) => O(e(Y)?.dueDatePolicy).with({ type: "PAYMENT_TERMS" }, ({ paymentTermDays: e }) => `Net ${e}`).with({ type: "MANUAL" }, Le.nullish, () => void 0).exhaustive()), gi = A((e) => e(Y)?.urlPayOnline), _i = A((e) => e(Y)?.showAutoChargeMessage ?? !1), vi = A((e) => e(Y)?.usePdfInvoiceAlternativeHeader ?? !1), yi = A((e) => e(Y)?.merchantLegalCompanyName ?? ""), bi = A((e) => e(Y)?.merchantLogoUrl), xi = A((e) => e(Y)?.customerLegalCompanyName ?? ""), Si = A((e) => {
	let t = e(Y);
	return t ? [
		e(yi),
		t.merchantEmail,
		...t.merchantAddress,
		...t.merchantTaxId ? [`${q.TAX_ID_PREFIX} ${t.merchantTaxId}`] : []
	] : [];
}), Ci = A((e) => {
	let t = e(Y);
	return t ? [
		e(xi),
		...t.customerAddress,
		...t.customerTaxId ? [`${q.TAX_ID_PREFIX} ${t.customerTaxId}`] : []
	].filter(Boolean) : [];
}), wi = A((e) => e(Y)?.invoiceNumber), Ti = A((e) => e(Y)?.memo), Ei = A((e) => {
	let t = e(Y);
	return t ? ai({
		lineItemGroups: t.lineItemGroups,
		currency: t.currency
	}) : [];
}), Di = A((e) => {
	let t = e(Y);
	return t ? oi({
		netTotal: t.netTotal,
		grossTotal: t.grossTotal,
		currency: t.currency,
		lineItemGroups: t.lineItemGroups,
		hasDeductions: e(fi)
	}) : [];
}), Oi = A((e) => e(Y)?.status ?? "SENT"), ki = A((e) => e(Y)?.customerTaxStatus === "REVERSE_CHARGED"), Ai = A((e) => {
	let t = e(Y)?.issueDate;
	return t ? y(t, nr) : void 0;
}), ji = A((e) => {
	let t = e(Y)?.accountingDate;
	return t ? y(t, nr) : void 0;
}), Mi = A((e) => {
	let t = e(Y)?.billingPeriod;
	if (t) return k({
		from: new Date(t.start),
		to: new Date(t.endInclusive)
	});
}), Ni = A((e) => e(Y)?.purchaseOrderNumber), Pi = A((e) => e(Y)?.reference), Fi = A((e) => e(Y)?.urlViewOnline), Ii = A((e) => {
	let t = e(Y)?.currency;
	if (t) return `${t} - ${ke(t)}`;
}), Li = A((e) => [
	{
		label: "Invoice no.",
		value: e(wi),
		href: e(Fi),
		width: "40%"
	},
	{
		label: "Invoice date",
		value: e(ji)
	},
	{
		label: "Issue date",
		value: e(Ai)
	},
	{
		label: "Due date",
		value: e(mi),
		"data-testid": "invoice.summary.dueDate"
	},
	{
		label: "Billing period",
		value: e(Mi)
	},
	{
		label: "Payment terms",
		value: e(hi),
		showSkeleton: !1,
		"data-testid": "invoice.summary.paymentTerms"
	},
	{
		label: "Currency",
		value: e(Ii)
	},
	{
		label: "PO number",
		value: e(Ni)
	},
	{
		label: "Reference",
		value: e(Pi)
	}
]), Ri = A((e) => {
	let t = e(Y);
	return t ? t.currencyConversions.map((e) => ({
		id: e.id,
		currency: e.currency,
		exchangeRateFrom: x({
			currency: t.currency,
			value: "1"
		}),
		exchangeRateTo: x({
			currency: e.currency,
			value: e.exchangeRate,
			maximumFractionDigits: 10
		}),
		subTotal: x({
			currency: e.currency,
			value: e.netTotal
		}),
		tax: x({
			currency: e.currency,
			value: e.totalTax
		}),
		total: x({
			currency: e.currency,
			value: e.grossTotal
		})
	})) : [];
}), zi = A((e) => {
	let t = e(Y);
	return t ? t.creditBalances.map((e) => ({
		id: e.id,
		name: e.name,
		totalBalance: O(e.type).with("CASH", () => x({
			currency: e.name,
			value: e.balance
		})).with("USAGE", () => `${e.balance} credits`).exhaustive(),
		grants: e.grants.map((e) => ({
			id: e.id,
			name: e.name,
			balance: O(e.type).with("CASH", () => `${x({
				currency: e.currency,
				value: e.currentBalance
			})}/${x({
				currency: e.currency,
				value: e.originalAmount
			})}`).with("USAGE", () => `${e.currentBalance}/${e.originalAmount} credits`).exhaustive(),
			expiresOn: e.expiryDate ? y(e.expiryDate, nr) : void 0
		}))
	})) : [];
}), Bi = A((e) => e(Y)?.subAccountUsage ?? []), Vi = A((e) => e(Y)?.paymentDetails ?? []), Hi = A((e) => e(Y)?.seatBreakdown ?? []), Ui = A((e) => e(Y)?.currency), Wi = A((e) => e(Y)?.invoiceTitle), Gi = A(!1), Ki = ({ row: e, value: t, isHeader: n, theme: r }) => ({
	textStyle: Ue(() => {
		if (n) return r.lineItemTable.header.cellText;
		let i = e[t];
		if (!i) return {};
		let { variant: a = "default" } = i;
		return {
			...r.lineItemTable.body.cellTextBase,
			...a === "secondary" ? r.lineItemTable.body.cellTextSecondary : {},
			...t === "name" && e.indentation === 0 ? r.lineItemTable.body.cellTextNameFirstLevel : {},
			...t === "name" && e.indentation !== 0 ? r.lineItemTable.body.cellTextNameSecondLevel : {}
		};
	}, [
		n,
		e,
		r,
		t
	]),
	captionStyle: r.lineItemTable.body.cellTextCaption
}), qi = ({ variant: e, theme: t }) => ({
	styleRow: Ue(() => O(e).with("default", () => t.totals.default.row).with("total", () => t.totals.total.row).with("grandTotal", () => t.totals.grandTotal.row).exhaustive(), [
		e,
		t.totals.default.row,
		t.totals.total.row,
		t.totals.grandTotal.row
	]),
	styleText: Ue(() => O(e).with("default", () => t.totals.default.text).with("total", () => t.totals.total.text).with("grandTotal", () => t.totals.grandTotal.text).exhaustive(), [
		e,
		t.totals.default.text,
		t.totals.total.text,
		t.totals.grandTotal.text
	])
}), Ji = A(!0), Yi = A({}), Xi = A(), Zi = () => {
	let e = j(pi), t = j(mi), n = j(gi), r = j(bi), i = j(yi), a = j(Wi), s = j(vi), c = j(G);
	return /* @__PURE__ */ w(o, {
		width: "100%",
		justifyContent: "space-between",
		...c.header.container,
		children: [/* @__PURE__ */ w(o, {
			flexDirection: "column",
			...c.header.total.container,
			flexShrink: "0",
			children: [
				a && /* @__PURE__ */ C(_, {
					...c.header.invoiceTitle,
					children: a
				}),
				/* @__PURE__ */ C(_, {
					"data-testid": "invoice.header.total",
					...s ? c.header.total.alternativeText : c.header.total.text,
					children: e
				}),
				(t || n) && /* @__PURE__ */ w(o, {
					...c.header.dueDatePayOnline.container,
					children: [t && /* @__PURE__ */ w(_, {
						"data-testid": "invoice.header.dueDate",
						...c.header.dueDatePayOnline.dueDateText,
						children: ["Due ", t]
					}), n && /* @__PURE__ */ C(_, {
						...c.header.dueDatePayOnline.urlPayOnlineText,
						children: "Pay online"
					})]
				})
			]
		}), r ? /* @__PURE__ */ C(ie, {
			src: r,
			...c.header.logo
		}) : /* @__PURE__ */ C(_, {
			...c.header.merchantName,
			children: i
		})]
	});
}, Qi = () => {
	let e = j(G);
	return /* @__PURE__ */ w(o, {
		gap: "4px",
		marginBottom: e.page.padding,
		children: [/* @__PURE__ */ C(_, {
			...e.poweredBy.text,
			children: "Powered by"
		}), /* @__PURE__ */ C(t, {
			transform: "translateY(1.5px)",
			children: /* @__PURE__ */ C(Ce, { ...e.poweredBy.logo })
		})]
	});
}, $i = () => {
	let e = We(null), n = Je(Xi), r = j(wi), i = j(pi), a = j(mi), s = j(G);
	return He(() => {
		if (!e.current) return;
		let { height: t } = e.current.getBoundingClientRect();
		n(t);
	}, [n]), /* @__PURE__ */ w(t, {
		ref: e,
		position: "absolute",
		bottom: "0",
		left: "0",
		background: ne,
		padding: s.page.padding,
		width: "100%",
		children: [/* @__PURE__ */ C(Qi, {}), /* @__PURE__ */ C(o, {
			...s.footer.container,
			children: /* @__PURE__ */ w(_, {
				"data-testid": "invoice.footer.summary",
				...s.footer.summary,
				children: [
					r && `${r} - `,
					/* @__PURE__ */ C(_, {
						as: "span",
						...s.footer.total,
						children: i
					}),
					" ",
					a && `due ${a}`
				]
			})
		})]
	});
}, ea = Be(({ children: e }, t) => {
	let n = j(G);
	return /* @__PURE__ */ C(p, {
		ref: t,
		width: "100%",
		templateColumns: `repeat(${n.gridSystem.columns}, 1fr)`,
		columnGap: n.gridSystem.columnGap,
		children: e
	});
}), ta = ({ width: e }) => /* @__PURE__ */ C(t, {
	width: e,
	height: "8px",
	borderRadius: "8px",
	background: l
}), na = [
	"80%",
	"65%",
	"70%",
	"75%"
], ra = ({ value: e, skeletonLines: t = 1, renderValue: n, children: r, width: i, "data-testid": a }) => {
	let s = j(Ji), c = Array.isArray(e) ? e.length > 0 : !!e;
	return !c && !s ? null : r(c ? n : /* @__PURE__ */ C(o, {
		flexDir: "column",
		gap: "4px",
		marginTop: "2px",
		"data-testid": a,
		children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ C(ta, { width: i ?? na[t % na.length] }, t))
	}));
}, ia = () => {
	let e = j(G), t = j(Ti), n = j(ki), r = j(Li);
	return /* @__PURE__ */ w(ea, { children: [/* @__PURE__ */ w(m, {
		colSpan: 7,
		children: [/* @__PURE__ */ C(_, {
			...e.summary.header,
			children: "Terms"
		}), /* @__PURE__ */ w(o, {
			flexDir: "column",
			...e.summary.containerTerms,
			children: [r.map((e) => /* @__PURE__ */ C(aa, { ...e }, e.label)), n && /* @__PURE__ */ C(_, {
				style: e.summary.value,
				children: q.REVERSE_CHARGED
			})]
		})]
	}), /* @__PURE__ */ C(ra, {
		value: t,
		renderValue: /* @__PURE__ */ C(_, {
			...e.summary.value,
			whiteSpace: "pre-line",
			children: t
		}),
		skeletonLines: 4,
		children: (t) => /* @__PURE__ */ w(m, {
			colSpan: 9,
			children: [/* @__PURE__ */ C(_, {
				...e.summary.header,
				children: "Memo"
			}), t]
		})
	})] });
}, aa = ({ label: e, value: t, href: n, width: r, showSkeleton: i = !0, "data-testid": a }) => {
	let o = j(G), s = n ? o.summary.valueLink : o.summary.value;
	return !t && !i ? null : /* @__PURE__ */ C(ra, {
		value: t,
		renderValue: /* @__PURE__ */ C(_, {
			...o.summary.value,
			...s,
			"data-testid": a,
			children: t
		}),
		skeletonLines: 1,
		width: r,
		"data-testid": a && `${a}.skeleton`,
		children: (t) => /* @__PURE__ */ w(p, {
			templateColumns: `${o.summary.label.container.width} 1fr`,
			children: [/* @__PURE__ */ C(m, { children: /* @__PURE__ */ C(_, {
				...o.summary.label.text,
				children: e
			}) }), /* @__PURE__ */ C(m, {
				alignContent: "center",
				wordBreak: "break-word",
				children: t
			})]
		})
	});
}, oa = ({ title: e, colSpan: t, lines: n }) => {
	let r = j(G);
	return /* @__PURE__ */ C(ra, {
		value: n,
		skeletonLines: 5,
		renderValue: n.map((e, t) => /* @__PURE__ */ C(_, {
			...r.contactDetails.body,
			children: e
		}, t)),
		children: (n) => /* @__PURE__ */ w(m, {
			colSpan: t,
			children: [/* @__PURE__ */ C(_, {
				...r.contactDetails.title,
				children: e
			}), n]
		})
	});
}, sa = () => {
	let e = j(Si), t = j(Ci);
	return /* @__PURE__ */ w(ea, { children: [/* @__PURE__ */ C(oa, {
		title: "From",
		colSpan: 7,
		lines: e
	}), /* @__PURE__ */ C(oa, {
		title: "To",
		colSpan: 9,
		lines: t
	})] });
}, ca = () => {
	let e = j(Di), t = j(ki), n = j(_i), r = j(G);
	return /* @__PURE__ */ C(ea, { children: /* @__PURE__ */ w(m, {
		colSpan: 9,
		colStart: 8,
		children: [/* @__PURE__ */ C(o, {
			flexDir: "column",
			...r.totals.container,
			children: e.map((e, t) => /* @__PURE__ */ C(la, { row: e }, t))
		}), (t || n) && /* @__PURE__ */ w(o, {
			flexDir: "column",
			...r.totalsCaptions.container,
			children: [t && /* @__PURE__ */ C(_, {
				...r.totalsCaptions.text,
				children: q.REVERSE_CHARGED
			}), n && /* @__PURE__ */ C(_, {
				...r.totalsCaptions.text,
				children: q.AUTO_CHARGED
			})]
		})]
	}) });
}, la = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default" } = e, { styleRow: i, styleText: a } = qi({
		variant: r,
		theme: j(G)
	});
	return /* @__PURE__ */ w(o, {
		...i,
		justifyContent: "space-between",
		width: "100%",
		children: [/* @__PURE__ */ C(_, {
			...a,
			children: t
		}), /* @__PURE__ */ C(_, {
			...a,
			children: n
		})]
	});
}, ua = () => {
	let e = j(Di), t = j(di), n = j(ki), r = j(_i), i = j(G);
	return /* @__PURE__ */ C(ea, { children: /* @__PURE__ */ w(m, {
		colSpan: 9,
		colStart: 8,
		"data-testid": "invoice.settlement",
		children: [/* @__PURE__ */ C(o, {
			flexDir: "column",
			children: [...e, ...t].map((e, t) => /* @__PURE__ */ C(da, { row: e }, t))
		}), (n || r) && /* @__PURE__ */ w(o, {
			flexDir: "column",
			...i.totalsCaptions.container,
			children: [n && /* @__PURE__ */ C(_, {
				...i.totalsCaptions.text,
				children: q.REVERSE_CHARGED
			}), r && /* @__PURE__ */ C(_, {
				...i.totalsCaptions.text,
				children: q.AUTO_CHARGED
			})]
		})]
	}) });
}, da = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default", href: i, testId: a } = e, s = j(G), { styleRow: c, styleText: l } = qi({
		variant: r,
		theme: s
	}), u = i ? s.totals.labelLink : l;
	return /* @__PURE__ */ w(o, {
		...c,
		paddingTop: "4px",
		paddingBottom: "4px",
		justifyContent: "space-between",
		width: "100%",
		"data-testid": a,
		children: [/* @__PURE__ */ C(_, {
			...u,
			...i ? {
				as: "a",
				href: i
			} : {},
			flex: 1,
			paddingRight: "8px",
			children: t
		}), /* @__PURE__ */ C(_, {
			...l,
			flexShrink: 0,
			textAlign: "right",
			children: n
		})]
	});
}, fa = ({ row: e, value: t, isHeader: n }) => {
	let r = j(G), { textStyle: i, captionStyle: a } = Ki({
		row: e,
		value: t,
		isHeader: n,
		theme: r
	}), s = e[t];
	return s?.variant === "skeleton" ? /* @__PURE__ */ C(o, {
		height: "15px",
		alignItems: "center",
		children: /* @__PURE__ */ C(ta, { width: "100%" })
	}) : /* @__PURE__ */ w(o, {
		flexDir: "column",
		...r.lineItemTable.body.cellContainer,
		children: [/* @__PURE__ */ C(_, {
			...i,
			children: s?.text
		}), s?.caption && t === "name" && /* @__PURE__ */ C(_, {
			...a,
			whiteSpace: "pre-line",
			children: s.caption
		})]
	});
}, pa = ({ row: e, isHeader: t = !1 }) => {
	let n = j(G), r = `${e.indentation * 8}px`, i = t ? n.lineItemTable.header.row : n.lineItemTable.body.row, a = {
		row: e,
		isHeader: t
	};
	return /* @__PURE__ */ w(p, {
		width: "100%",
		templateColumns: "repeat(16, 1fr)",
		columnGap: "16px",
		...i,
		children: [
			/* @__PURE__ */ C(m, {
				gridColumn: "span 7",
				paddingLeft: r,
				children: /* @__PURE__ */ C(fa, {
					...a,
					value: "name"
				})
			}),
			/* @__PURE__ */ C(m, {
				gridColumn: "span 2",
				children: /* @__PURE__ */ C(fa, {
					...a,
					value: "quantity"
				})
			}),
			/* @__PURE__ */ C(m, {
				gridColumn: "span 2",
				textAlign: "right",
				children: /* @__PURE__ */ C(fa, {
					...a,
					value: "rate"
				})
			}),
			/* @__PURE__ */ C(m, {
				gridColumn: "span 2",
				textAlign: "right",
				children: /* @__PURE__ */ C(fa, {
					...a,
					value: "tax"
				})
			}),
			/* @__PURE__ */ C(m, {
				gridColumn: "span 3",
				textAlign: "right",
				children: /* @__PURE__ */ C(fa, {
					...a,
					value: "amount"
				})
			})
		]
	});
}, ma = () => /* @__PURE__ */ C(pa, {
	isHeader: !0,
	row: {
		name: { text: "Name" },
		quantity: { text: "Qty" },
		rate: { text: "Rate" },
		tax: { text: "Tax" },
		amount: { text: "Amount" },
		indentation: 0
	}
}), ha = () => /* @__PURE__ */ C(pa, { row: {
	name: {
		text: "Name",
		variant: "skeleton"
	},
	quantity: {
		text: "Qty",
		variant: "skeleton"
	},
	rate: {
		text: "Rate",
		variant: "skeleton"
	},
	tax: {
		text: "Tax",
		variant: "skeleton"
	},
	amount: {
		text: "Price",
		variant: "skeleton"
	},
	indentation: 0
} }), ga = () => {
	let e = j(Ei), t = j(Ji);
	return /* @__PURE__ */ w(o, {
		flexDir: "column",
		width: "100%",
		children: [/* @__PURE__ */ C(ma, {}), e.length === 0 && t ? /* @__PURE__ */ C(ha, {}) : e.map((e, t) => /* @__PURE__ */ C(pa, { row: e }, t))]
	});
}, _a = () => j(Oi) === "VOIDED" ? /* @__PURE__ */ C(va, { text: "VOID" }) : null, va = ({ text: e }) => /* @__PURE__ */ C(r, {
	width: "100%",
	height: 960,
	zIndex: "1",
	position: "absolute",
	top: "0",
	left: "0",
	children: /* @__PURE__ */ C(_, {
		...j(G).watermark.text,
		children: e
	})
}), ya = ({ scale: e }) => {
	let n = We(null), r = Je(Yi), i = j(G), a = j(Xi), s = j(Y), c = j(fi);
	return He(() => {
		if (!n.current) return;
		let e = n.current.getBoundingClientRect();
		r({
			width: e.width,
			height: e.height
		});
	}, [
		r,
		a,
		s,
		e
	]), /* @__PURE__ */ w(t, {
		ref: n,
		width: "680px",
		minHeight: "960px",
		background: ne,
		position: "relative",
		transform: `scale(${e})`,
		transformOrigin: "top left",
		...i.page,
		children: [
			/* @__PURE__ */ w(o, {
				flexDirection: "column",
				alignItems: "flex-start",
				...i.mainPage,
				paddingBottom: `${a}px`,
				children: [
					/* @__PURE__ */ C(Zi, {}),
					/* @__PURE__ */ C(sa, {}),
					/* @__PURE__ */ C(ia, {}),
					/* @__PURE__ */ w(o, {
						flexDir: "column",
						width: "100%",
						...i.lineItems.container,
						children: [/* @__PURE__ */ C(ga, {}), C(c ? ua : ca, {})]
					})
				]
			}),
			/* @__PURE__ */ C($i, {}),
			/* @__PURE__ */ C(_a, {})
		]
	});
}, ba = (e) => {
	let [n, i] = qe(Y), [a, o] = qe($n), [s, c] = qe(Ji), l = j(Yi);
	Ve(() => {
		e.data && !Ye(e.data, n) && i(e.data);
	}, [
		n,
		e.data,
		i
	]), Ve(() => {
		e.theme !== a && o(e.theme);
	}, [
		a,
		e.theme,
		o
	]), Ve(() => {
		e.showSkeletons !== s && c(e.showSkeletons);
	}, [
		s,
		e.showSkeletons,
		c
	]);
	let u = e.width / 680;
	return n ? /* @__PURE__ */ C(t, {
		width: l.width,
		height: l.height,
		overflow: "hidden",
		userSelect: "none",
		"data-testid": e["data-testid"],
		children: /* @__PURE__ */ C(ya, { scale: u })
	}) : /* @__PURE__ */ C(r, {
		width: 680 * u,
		height: 960 * u,
		children: /* @__PURE__ */ C(_e, {})
	});
}, xa = (e) => /* @__PURE__ */ C(Ke, { children: /* @__PURE__ */ C(ba, { ...e }) }), Sa = ({ summary: e }) => {
	let t = j(K);
	return /* @__PURE__ */ C(D, {
		fixed: !0,
		style: {
			position: "absolute",
			bottom: 0,
			left: t.page.padding,
			width: "100%",
			paddingTop: t.page.padding,
			paddingBottom: t.page.padding
		},
		children: /* @__PURE__ */ w(D, {
			style: {
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
				...t.footer.container
			},
			children: [/* @__PURE__ */ C(E, {
				style: t.footer.summary,
				children: e
			}), /* @__PURE__ */ C(E, {
				style: t.footer.summary,
				render: ({ pageNumber: e, totalPages: t }) => `Page ${e} of ${t}`
			})]
		})
	});
}, Ca = (e) => {
	let t = parseFloat(e.footer.container.paddingTop), n = parseFloat(e.footer.summary.fontSize), r = parseFloat(e.page.padding), i = parseFloat(e.footer.container.borderTopWidth);
	return `${r * 2 + i + n + t}px`;
}, wa = ({ status: e }) => {
	let t = j(Gi);
	return /* @__PURE__ */ w(S, { children: [O(e).with("DRAFT", () => /* @__PURE__ */ C(Ta, { text: "DRAFT" })).with("VOIDED", () => /* @__PURE__ */ C(Ta, { text: "VOID" })).with("FINAL", "IN_PROGRESS", "SENT", () => null).exhaustive(), t && /* @__PURE__ */ C(Ta, { text: "TEST" })] });
}, Ta = ({ text: e }) => {
	let t = j(K);
	return /* @__PURE__ */ C(D, {
		fixed: !0,
		style: {
			width: "100%",
			height: "100%",
			position: "absolute",
			top: `${parseInt(t.page.padding, 10) * 2}px`,
			left: t.page.padding,
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		},
		children: /* @__PURE__ */ C(E, {
			style: t.watermark.text,
			children: e
		})
	});
}, Ea = ({ children: e, footerSummary: t, status: n }) => {
	let r = j(K), i = Ca(r);
	return /* @__PURE__ */ w(Pe, {
		size: "A4",
		dpi: 72,
		style: { padding: `${r.page.padding} ${r.page.padding} ${i}` },
		children: [
			e,
			/* @__PURE__ */ C(Sa, { summary: t }),
			/* @__PURE__ */ C(wa, { status: n })
		]
	});
}, X = ({ children: e, style: t = {}, wrap: n = !0 }) => /* @__PURE__ */ C(D, {
	wrap: n,
	children: /* @__PURE__ */ C(D, {
		style: {
			...t,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between"
		},
		children: e
	})
}), Z = ({ colSpan: e, colStart: t, children: n, style: r = {} }) => {
	let i = j(K), a = i.gridSystem.columns, o = parseInt(i.gridSystem.columnGap, 10), s = (595 - 2 * parseInt(i.page.padding, 10) - (a - 1) * o) / a, c = e * s + (e - 1) * o, l = t ? (t - 1) * s + (t - 1) * o : 0;
	return /* @__PURE__ */ C(D, {
		style: {
			...r,
			width: `${c}px`,
			marginLeft: `${l}px`
		},
		children: n
	});
}, Q = Object.assign(({ children: e }) => /* @__PURE__ */ C(D, {
	style: {
		display: "flex",
		flexDirection: "column",
		...j(K).detailsBlock.container
	},
	children: e
}), {
	Header: Object.assign(({ children: e }) => /* @__PURE__ */ C(D, {
		style: {
			display: "flex",
			flexDirection: "column",
			...j(K).detailsBlock.header.container
		},
		children: e
	}), {
		Title: ({ children: e }) => /* @__PURE__ */ C(E, {
			style: j(K).detailsBlock.header.title,
			children: e
		}),
		Subtitle: ({ children: e }) => /* @__PURE__ */ C(E, {
			style: j(K).detailsBlock.header.subtitle,
			children: e
		})
	}),
	Group: ({ title: e, children: t, spacing: n = "default" }) => {
		let r = j(K);
		return /* @__PURE__ */ w(D, {
			style: {
				display: "flex",
				flexDirection: "column",
				...r.detailsBlock.group.container[n]
			},
			children: [e && /* @__PURE__ */ C(E, {
				style: r.detailsBlock.group.title,
				children: e
			}), t]
		});
	},
	Item: ({ title: e, titleColSpan: t = 3, children: n }) => {
		let r = j(K), i = r.gridSystem.columns - t;
		return /* @__PURE__ */ w(X, {
			wrap: !1,
			children: [/* @__PURE__ */ C(Z, {
				colSpan: t,
				children: C(typeof e == "string" ? E : D, {
					style: r.detailsBlock.item.title,
					children: e
				})
			}), /* @__PURE__ */ C(Z, {
				colSpan: i,
				children: /* @__PURE__ */ C(D, {
					style: {
						display: "flex",
						flexDirection: "column",
						...r.detailsBlock.item.values.container,
						...r.detailsBlock.item.values.text
					},
					children: n
				})
			})]
		});
	}
}), Da = ({ width: e, height: t }) => {
	let n = "#241F25";
	return /* @__PURE__ */ w(Ie, {
		width: e,
		height: t,
		viewBox: "0 0 65 17",
		fill: "none",
		children: [
			/* @__PURE__ */ C(T, {
				d: "M5.36695 13.4171C6.63862 13.4171 7.64413 13.1422 8.36869 12.5923C9.09324 12.0423 9.46291 11.2898 9.46291 10.3347C9.46291 9.5388 9.19675 8.90206 8.66442 8.42451C8.1321 7.96143 7.27446 7.59964 6.07672 7.33916L5.15994 7.15103C4.27272 6.97738 3.68125 6.74584 3.35594 6.48535C3.03063 6.25381 2.86797 5.89203 2.86797 5.41447C2.86797 4.95139 3.04541 4.60408 3.41509 4.3436C3.76997 4.09758 4.3023 3.96734 4.99728 3.96734C5.88449 3.96734 6.52033 4.12653 6.91957 4.4449C7.31882 4.76327 7.54062 5.24082 7.59977 5.9065H9.16718C9.1376 4.89351 8.78272 4.09758 8.08774 3.51873C7.39275 2.93988 6.35767 2.65045 4.98249 2.65045C3.82912 2.65045 2.92712 2.91094 2.26171 3.41743C1.58151 3.92393 1.2562 4.60408 1.2562 5.44342C1.2562 6.29723 1.52237 6.96291 2.08427 7.44046C2.63138 7.93248 3.44466 8.2798 4.53889 8.48239L5.44089 8.67052C6.3281 8.87312 6.94915 9.09019 7.30403 9.3362C7.64413 9.58222 7.82157 9.92953 7.82157 10.3781C7.82157 10.9425 7.59977 11.3767 7.18574 11.6661C6.7717 11.9555 6.16544 12.1002 5.39653 12.1002C3.50381 12.1002 2.55745 11.3332 2.52787 9.78481H0.945679C0.945679 10.9715 1.34492 11.8832 2.11384 12.491C2.88276 13.1132 3.97699 13.4171 5.36695 13.4171Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M17.4454 9.50986C17.4454 8.35215 17.12 7.41152 16.4842 6.65901C15.8336 5.92097 14.9464 5.54472 13.8226 5.54472C12.7431 5.54472 11.8707 5.9065 11.2053 6.61559C10.5251 7.33916 10.1998 8.2798 10.1998 9.45197C10.1998 10.6386 10.5251 11.5793 11.2053 12.2884C11.8707 13.0119 12.7579 13.3592 13.8521 13.3592C14.7246 13.3592 15.4639 13.1422 16.0554 12.708C16.6469 12.2739 17.0609 11.6661 17.2679 10.8991H15.7744C15.4787 11.7384 14.8429 12.1436 13.8817 12.1436C13.2311 12.1436 12.7283 11.97 12.3587 11.5937C11.9742 11.2175 11.7524 10.6676 11.6933 9.92953H17.4454V9.50986ZM13.8226 6.76031C14.414 6.76031 14.8872 6.94843 15.2569 7.32469C15.6266 7.70094 15.8484 8.1785 15.9223 8.78629H11.7081C11.7968 8.13508 12.0186 7.62859 12.3882 7.28127C12.7579 6.93396 13.2311 6.76031 13.8226 6.76031Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M24.1134 6.81819C23.5367 5.97886 22.6938 5.54472 21.5848 5.54472C20.5202 5.54472 19.6625 5.9065 19.0415 6.60112C18.4057 7.31022 18.0951 8.26533 18.0951 9.45197C18.0951 10.6531 18.4057 11.6082 19.0415 12.3028C19.6625 13.0119 20.5202 13.3592 21.5848 13.3592C22.6495 13.3592 23.4775 12.9685 24.0542 12.1726V16.022H25.5329V5.71837H24.1134V6.81819ZM20.2392 11.4345C19.8252 10.9859 19.633 10.3492 19.633 9.50986C19.633 8.67052 19.8252 8.00484 20.2392 7.51282C20.6385 7.03526 21.1856 6.78925 21.8658 6.78925C22.5608 6.78925 23.1079 7.02079 23.5071 7.48387C23.8916 7.96143 24.0986 8.61264 24.0986 9.45197C24.0986 10.3058 23.8916 10.957 23.5071 11.4056C23.1079 11.8832 22.5608 12.1147 21.8658 12.1147C21.1856 12.1147 20.6385 11.8976 20.2392 11.4345Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M31.9068 9.92953C31.9068 10.6097 31.7146 11.1451 31.3449 11.5214C30.9753 11.8976 30.5169 12.0858 29.9845 12.0858C28.9051 12.0858 28.3728 11.5648 28.3728 10.5229V5.71837H26.8941V10.7254C26.8941 11.5648 27.1307 12.2015 27.6039 12.6646C28.077 13.1277 28.7277 13.3592 29.5705 13.3592C30.576 13.3592 31.3745 12.9396 31.966 12.0713V13.1856H33.3855V5.71837H31.9068V9.92953Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M41.6368 9.50986C41.6368 8.35215 41.3115 7.41152 40.6756 6.65901C40.025 5.92097 39.1378 5.54472 38.014 5.54472C36.9346 5.54472 36.0621 5.9065 35.3967 6.61559C34.7165 7.33916 34.3912 8.2798 34.3912 9.45197C34.3912 10.6386 34.7165 11.5793 35.3967 12.2884C36.0621 13.0119 36.9493 13.3592 38.0436 13.3592C38.916 13.3592 39.6553 13.1422 40.2468 12.708C40.8383 12.2739 41.2523 11.6661 41.4593 10.8991H39.9659C39.6701 11.7384 39.0343 12.1436 38.0731 12.1436C37.4225 12.1436 36.9198 11.97 36.5501 11.5937C36.1656 11.2175 35.9438 10.6676 35.8847 9.92953H41.6368V9.50986ZM38.014 6.76031C38.6055 6.76031 39.0786 6.94843 39.4483 7.32469C39.818 7.70094 40.0398 8.1785 40.1137 8.78629H35.8995C35.9882 8.13508 36.21 7.62859 36.5797 7.28127C36.9493 6.93396 37.4225 6.76031 38.014 6.76031Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M46.4564 5.54472C45.4362 5.54472 44.6377 5.97886 44.061 6.83266V5.71837H42.6414V13.1856H44.1201V8.97442C44.1201 8.2798 44.3124 7.74436 44.7116 7.3681C45.0961 7.00632 45.5397 6.81819 46.0424 6.81819C47.1071 6.81819 47.6542 7.33916 47.6542 8.3811V13.1856H49.1329V8.1785C49.1329 7.33916 48.8963 6.70242 48.4231 6.23934C47.9499 5.77626 47.2845 5.54472 46.4564 5.54472Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M53.7761 13.3592C54.6929 13.3592 55.4618 13.1132 56.0829 12.5923C56.7039 12.0858 57.0736 11.3911 57.1919 10.5229H55.6836C55.5949 11.0438 55.3731 11.4345 55.033 11.695C54.6781 11.97 54.2641 12.1002 53.7761 12.1002C53.1255 12.1002 52.6228 11.8832 52.2383 11.4201C51.8538 10.957 51.6764 10.3058 51.6764 9.45197C51.6764 8.61264 51.8538 7.96143 52.2383 7.49834C52.6228 7.03526 53.1255 6.80372 53.7761 6.80372C54.2493 6.80372 54.6633 6.93396 55.0034 7.19445C55.3435 7.45493 55.5653 7.83119 55.6689 8.32321H57.1771C57.0588 7.48387 56.6891 6.80372 56.0829 6.29723C55.4766 5.8052 54.7077 5.54472 53.7761 5.54472C52.6819 5.54472 51.7947 5.9065 51.1441 6.60112C50.4639 7.32469 50.1386 8.26533 50.1386 9.45197C50.1386 10.6386 50.4639 11.5793 51.1441 12.2884C51.8095 13.0119 52.6819 13.3592 53.7761 13.3592Z",
				fill: n
			}),
			/* @__PURE__ */ C(T, {
				d: "M64.9473 9.50986C64.9473 8.35215 64.622 7.41152 63.9862 6.65901C63.3356 5.92097 62.4484 5.54472 61.3246 5.54472C60.2451 5.54472 59.3727 5.9065 58.7073 6.61559C58.0271 7.33916 57.7018 8.2798 57.7018 9.45197C57.7018 10.6386 58.0271 11.5793 58.7073 12.2884C59.3727 13.0119 60.2599 13.3592 61.3541 13.3592C62.2266 13.3592 62.9659 13.1422 63.5574 12.708C64.1488 12.2739 64.5629 11.6661 64.7699 10.8991H63.2764C62.9807 11.7384 62.3449 12.1436 61.3837 12.1436C60.7331 12.1436 60.2303 11.97 59.8607 11.5937C59.4762 11.2175 59.2544 10.6676 59.1952 9.92953H64.9473V9.50986ZM61.3246 6.76031C61.916 6.76031 62.3892 6.94843 62.7589 7.32469C63.1286 7.70094 63.3504 8.1785 63.4243 8.78629H59.21C59.2988 8.13508 59.5206 7.62859 59.8902 7.28127C60.2599 6.93396 60.7331 6.76031 61.3246 6.76031Z",
				fill: n
			})
		]
	});
}, Oa = ({ utmCampaign: e }) => {
	let t = j(K), n = `https://sequencehq.com/?utm_campaign=${e}`;
	return /* @__PURE__ */ C(D, {
		style: {
			position: "absolute",
			bottom: Ca(t),
			left: t.page.padding
		},
		children: /* @__PURE__ */ w(Ne, {
			href: n,
			style: {
				gap: "2px",
				display: "flex",
				flexDirection: "row",
				textDecoration: "none"
			},
			children: [/* @__PURE__ */ C(E, {
				style: t.poweredBy.text,
				children: "Powered by"
			}), /* @__PURE__ */ C(Da, { ...t.poweredBy.logo })]
		})
	});
}, ka = (e) => {
	let t = typeof window < "u" ? {
		uri: e.src,
		method: "GET",
		headers: { "Cache-Control": "no-cache" },
		body: ""
	} : e.src;
	return /* @__PURE__ */ C(Me, {
		...e,
		src: t
	});
}, Aa = ({ title: e, headline: t, isAlternativeHeadline: n = !1, subline: r, logoUrl: i, merchantName: a }) => {
	let o = j(K);
	return /* @__PURE__ */ w(D, {
		style: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			...o.header.container
		},
		children: [/* @__PURE__ */ w(D, {
			style: o.header.total.container,
			children: [
				e && /* @__PURE__ */ C(E, {
					style: o.header.invoiceTitle,
					children: e
				}),
				/* @__PURE__ */ C(E, {
					style: n ? o.header.total.alternativeText : o.header.total.text,
					children: t
				}),
				r && /* @__PURE__ */ C(D, {
					style: {
						display: "flex",
						flexDirection: "row",
						...o.header.dueDatePayOnline.container
					},
					children: r
				})
			]
		}), i ? /* @__PURE__ */ C(ka, {
			src: i,
			style: o.header.logo
		}) : /* @__PURE__ */ C(D, {
			style: { flex: 1 },
			children: /* @__PURE__ */ C(E, {
				style: o.header.merchantName,
				children: a
			})
		})]
	});
}, ja = ({ title: e, colSpan: t, lines: n }) => {
	let r = j(K);
	return /* @__PURE__ */ w(Z, {
		colSpan: t,
		children: [/* @__PURE__ */ C(E, {
			style: r.contactDetails.title,
			children: e
		}), n.map((e, t) => /* @__PURE__ */ C(E, {
			style: r.contactDetails.body,
			children: e
		}, t))]
	});
}, Ma = ({ merchant: e, customer: t }) => /* @__PURE__ */ w(X, { children: [/* @__PURE__ */ C(ja, {
	title: e.title,
	colSpan: 7,
	lines: e.lines
}), /* @__PURE__ */ C(ja, {
	title: t.title,
	colSpan: 9,
	lines: t.lines
})] }), Na = ({ heading: e, items: t, footnote: n, memo: r }) => {
	let i = j(K);
	return /* @__PURE__ */ w(X, { children: [/* @__PURE__ */ w(Z, {
		colSpan: 7,
		children: [e && /* @__PURE__ */ C(E, {
			style: i.summary.header,
			children: e
		}), /* @__PURE__ */ w(D, {
			style: i.summary.containerTerms,
			children: [t.map((e) => /* @__PURE__ */ C(Pa, { ...e }, e.label)), n && /* @__PURE__ */ C(E, {
				style: i.summary.value,
				children: n
			})]
		})]
	}), r && /* @__PURE__ */ w(Z, {
		colSpan: 9,
		children: [r.heading && /* @__PURE__ */ C(E, {
			style: i.summary.header,
			children: r.heading
		}), /* @__PURE__ */ C(E, {
			style: i.summary.value,
			hyphenationCallback: (e) => [e],
			children: r.text
		})]
	})] });
}, Pa = ({ label: e, value: t, href: n }) => {
	let r = j(K);
	return t ? /* @__PURE__ */ w(D, {
		style: {
			display: "flex",
			flexDirection: "row"
		},
		children: [/* @__PURE__ */ C(D, {
			style: r.summary.label.container,
			children: /* @__PURE__ */ C(E, {
				style: r.summary.label.text,
				children: e
			})
		}), /* @__PURE__ */ C(D, {
			style: { flex: 1 },
			children: n ? /* @__PURE__ */ C(Ne, {
				href: n,
				style: r.summary.valueLink,
				children: t
			}) : /* @__PURE__ */ C(E, {
				style: r.summary.value,
				children: t
			})
		})]
	}) : null;
}, Fa = ({ row: e, value: t, isHeader: n }) => {
	let r = j(K), { textStyle: i, captionStyle: a } = Ki({
		row: e,
		value: t,
		isHeader: n,
		theme: r
	}), o = e[t];
	return o?.variant === "skeleton" ? null : /* @__PURE__ */ w(D, {
		style: {
			display: "flex",
			flexDirection: "column",
			...r.lineItemTable.body.cellContainer
		},
		children: [/* @__PURE__ */ C(E, {
			style: i,
			children: o?.text
		}), o?.caption && t === "name" && /* @__PURE__ */ C(E, {
			style: a,
			children: o.caption
		})]
	});
}, Ia = ({ row: e, isHeader: t = !1 }) => {
	let n = j(K), r = `${e.indentation * parseInt(n.lineItemTable.body.rowIndentation.paddingLeft, 10)}px`, i = t ? n.lineItemTable.header.row : n.lineItemTable.body.row, a = {
		row: e,
		isHeader: t
	};
	return /* @__PURE__ */ w(X, {
		style: i,
		wrap: e.indentation === 0,
		children: [
			/* @__PURE__ */ C(Z, {
				colSpan: 7,
				style: { paddingLeft: r },
				children: /* @__PURE__ */ C(Fa, {
					...a,
					value: "name"
				})
			}),
			/* @__PURE__ */ C(Z, {
				colSpan: 2,
				children: /* @__PURE__ */ C(Fa, {
					...a,
					value: "quantity"
				})
			}),
			/* @__PURE__ */ C(Z, {
				colSpan: 2,
				style: { textAlign: "right" },
				children: /* @__PURE__ */ C(Fa, {
					...a,
					value: "rate"
				})
			}),
			/* @__PURE__ */ C(Z, {
				colSpan: 2,
				style: { textAlign: "right" },
				children: /* @__PURE__ */ C(Fa, {
					...a,
					value: "tax"
				})
			}),
			/* @__PURE__ */ C(Z, {
				colSpan: 3,
				style: { textAlign: "right" },
				children: /* @__PURE__ */ C(Fa, {
					...a,
					value: "amount"
				})
			})
		]
	});
}, La = ({ columnLabels: e }) => /* @__PURE__ */ C(Ia, {
	isHeader: !0,
	row: {
		name: { text: e.name },
		quantity: { text: e.quantity },
		rate: { text: e.rate },
		tax: { text: e.tax },
		amount: { text: e.amount },
		indentation: 0
	}
}), Ra = ({ rows: e, columnLabels: t }) => /* @__PURE__ */ w(D, { children: [/* @__PURE__ */ C(La, { columnLabels: t }), e.map((e, t) => /* @__PURE__ */ C(Ia, { row: e }, t))] }), za = ({ rows: e }) => /* @__PURE__ */ C(D, {
	style: {
		display: "flex",
		flexDirection: "column",
		...j(K).totals.container
	},
	children: e.map((e, t) => /* @__PURE__ */ C(Ba, { row: e }, t))
}), Ba = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default" } = e, { styleRow: i, styleText: a } = qi({
		variant: r,
		theme: j(K)
	});
	return /* @__PURE__ */ C(D, { children: /* @__PURE__ */ w(D, {
		style: {
			...i,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			width: "100%"
		},
		children: [/* @__PURE__ */ C(E, {
			style: a,
			children: t
		}), /* @__PURE__ */ C(E, {
			style: a,
			children: n
		})]
	}) });
}, $ = ({ children: e }) => {
	let t = j(K), n = j(wi), r = j(pi), i = j(mi);
	return /* @__PURE__ */ C(Ea, {
		status: j(Oi),
		footerSummary: /* @__PURE__ */ w(S, { children: [
			n && `${n} - `,
			/* @__PURE__ */ C(E, {
				style: t.footer.total,
				children: r
			}),
			" ",
			i && `due ${i}`
		] }),
		children: e
	});
}, Va = () => {
	let e = j(pi), t = j(mi), n = j(gi), r = j(bi), i = j(yi), a = j(Wi), o = j(vi), s = j(K);
	return /* @__PURE__ */ C(Aa, {
		title: a,
		headline: e,
		isAlternativeHeadline: o,
		logoUrl: r,
		merchantName: i,
		subline: t || n ? /* @__PURE__ */ w(S, { children: [t && /* @__PURE__ */ w(E, {
			style: s.header.dueDatePayOnline.dueDateText,
			children: ["Due ", t]
		}), n && /* @__PURE__ */ C(Ne, {
			src: n,
			style: s.header.dueDatePayOnline.urlPayOnlineText,
			children: "Pay online"
		})] }) : void 0
	});
}, Ha = () => {
	let e = j(Si), t = j(Ci);
	return /* @__PURE__ */ C(Ma, {
		merchant: {
			title: "From",
			lines: e
		},
		customer: {
			title: "To",
			lines: t
		}
	});
}, Ua = () => {
	let e = j(Ti), t = j(ki);
	return /* @__PURE__ */ C(Na, {
		heading: "Terms",
		items: j(Li),
		footnote: t ? q.REVERSE_CHARGED : void 0,
		memo: e ? {
			heading: "Memo",
			text: e
		} : void 0
	});
}, Wa = {
	name: "Name",
	quantity: "Qty",
	rate: "Rate",
	tax: "Tax",
	amount: "Amount"
}, Ga = () => /* @__PURE__ */ C(Ra, {
	rows: j(Ei),
	columnLabels: Wa
}), Ka = () => {
	let e = j(ki), t = j(_i), n = j(K);
	return !e && !t ? null : /* @__PURE__ */ w(D, {
		style: {
			display: "flex",
			flexDirection: "column",
			...n.totalsCaptions.container
		},
		children: [e && /* @__PURE__ */ C(E, {
			style: n.totalsCaptions.text,
			children: q.REVERSE_CHARGED
		}), t && /* @__PURE__ */ C(E, {
			style: n.totalsCaptions.text,
			children: q.AUTO_CHARGED
		})]
	});
}, qa = () => /* @__PURE__ */ C(X, {
	wrap: !1,
	children: /* @__PURE__ */ w(Z, {
		colSpan: 9,
		colStart: 8,
		children: [/* @__PURE__ */ C(za, { rows: j(Di) }), /* @__PURE__ */ C(Ka, {})]
	})
}), Ja = () => {
	let e = j(Di), t = j(di);
	return /* @__PURE__ */ C(X, {
		wrap: !1,
		children: /* @__PURE__ */ w(Z, {
			colSpan: 9,
			colStart: 8,
			children: [/* @__PURE__ */ C(D, {
				style: {
					display: "flex",
					flexDirection: "column"
				},
				children: [...e, ...t].map((e, t) => /* @__PURE__ */ C(Ya, { row: e }, t))
			}), /* @__PURE__ */ C(Ka, {})]
		})
	});
}, Ya = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default", href: i } = e, a = j(K), { styleRow: o, styleText: s } = qi({
		variant: r,
		theme: a
	}), c = {
		flex: 1,
		paddingRight: "8px"
	};
	return /* @__PURE__ */ w(D, {
		style: {
			...o,
			paddingTop: "4px",
			paddingBottom: "4px",
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			width: "100%"
		},
		children: [i ? /* @__PURE__ */ C(Ne, {
			href: i,
			style: {
				...a.totals.labelLink,
				...c
			},
			children: t
		}) : /* @__PURE__ */ C(E, {
			style: {
				...s,
				...c
			},
			children: t
		}), /* @__PURE__ */ C(E, {
			style: {
				...s,
				flexShrink: 0,
				textAlign: "right"
			},
			children: n
		})]
	});
}, Xa = () => {
	let e = j(K), t = j(fi);
	return /* @__PURE__ */ w($, { children: [/* @__PURE__ */ w(D, {
		style: e.mainPage,
		children: [
			/* @__PURE__ */ C(Va, {}),
			/* @__PURE__ */ C(Ha, {}),
			/* @__PURE__ */ C(Ua, {}),
			/* @__PURE__ */ w(D, {
				style: e.lineItems.container,
				children: [/* @__PURE__ */ C(Ga, {}), C(t ? Ja : qa, {})]
			})
		]
	}), /* @__PURE__ */ C(Oa, { utmCampaign: "pdf-invoice" })] });
}, Za = () => {
	let t = j(K), n = j(Ri);
	return n.length ? /* @__PURE__ */ C($, { children: /* @__PURE__ */ w(Q, { children: [/* @__PURE__ */ C(Q.Header, { children: /* @__PURE__ */ C(Q.Header.Title, { children: "Currency conversion" }) }), n.map((n) => /* @__PURE__ */ w(Q.Group, { children: [
		/* @__PURE__ */ C(Q.Item, {
			title: "Currency",
			children: /* @__PURE__ */ C(E, { children: n.currency })
		}),
		/* @__PURE__ */ C(Q.Item, {
			title: "Exchange rate",
			children: /* @__PURE__ */ w(D, {
				style: {
					flexDirection: "row",
					alignItems: "center",
					...t.currencyConversion.exchangeRate.container
				},
				children: [
					/* @__PURE__ */ C(E, { children: n.exchangeRateFrom }),
					/* @__PURE__ */ C(e, {
						style: {
							position: "relative",
							top: "-0.5px"
						},
						...t.currencyConversion.exchangeRate.icon
					}),
					/* @__PURE__ */ C(E, { children: n.exchangeRateTo })
				]
			})
		}),
		/* @__PURE__ */ C(Q.Item, {
			title: "Subtotal",
			children: /* @__PURE__ */ C(E, { children: n.subTotal })
		}),
		/* @__PURE__ */ C(Q.Item, {
			title: "Tax",
			children: /* @__PURE__ */ C(E, { children: n.tax })
		}),
		/* @__PURE__ */ C(Q.Item, {
			title: "Total",
			children: /* @__PURE__ */ C(E, { children: n.total })
		})
	] }, n.id))] }) }) : null;
}, Qa = () => {
	let e = j(zi);
	return e.length ? /* @__PURE__ */ C($, { children: /* @__PURE__ */ w(Q, { children: [/* @__PURE__ */ C(Q.Header, { children: /* @__PURE__ */ C(Q.Header.Title, { children: "Credits" }) }), e.map((e) => /* @__PURE__ */ w(Q.Group, {
		title: e.name,
		spacing: "lg",
		children: [/* @__PURE__ */ C(Q.Item, {
			title: /* @__PURE__ */ C(E, {
				style: { fontWeight: 600 },
				children: "Total balance"
			}),
			children: /* @__PURE__ */ C(E, {
				style: { fontWeight: 600 },
				children: e.totalBalance
			})
		}), e.grants.map((e) => /* @__PURE__ */ w(Q.Group, { children: [
			/* @__PURE__ */ C(Q.Item, {
				title: "Name",
				children: /* @__PURE__ */ C(E, { children: e.name })
			}),
			/* @__PURE__ */ C(Q.Item, {
				title: "Balance",
				children: /* @__PURE__ */ C(E, { children: e.balance })
			}),
			e.expiresOn && /* @__PURE__ */ C(Q.Item, {
				title: "Expires on",
				children: /* @__PURE__ */ C(E, { children: e.expiresOn })
			})
		] }, e.id))]
	}, e.id))] }) }) : null;
}, $a = () => {
	let e = j(yi), t = j(Vi);
	return t.length ? /* @__PURE__ */ C($, { children: /* @__PURE__ */ w(Q, { children: [/* @__PURE__ */ w(Q.Header, { children: [/* @__PURE__ */ C(Q.Header.Title, { children: "Payment details" }), /* @__PURE__ */ w(Q.Header.Subtitle, { children: ["Use the details below to pay ", e] })] }), t.map((e, t) => /* @__PURE__ */ C(Q.Group, {
		title: e.description,
		children: e.fields.map(({ label: e, lines: t }, n) => /* @__PURE__ */ C(Q.Item, {
			title: e,
			titleColSpan: 8,
			children: t.map((e, t) => /* @__PURE__ */ C(E, { children: e }, t))
		}, n))
	}, t))] }) }) : null;
}, eo = () => {
	let e = j(Bi);
	return e.length ? /* @__PURE__ */ C($, { children: /* @__PURE__ */ w(Q, { children: [/* @__PURE__ */ C(Q.Header, { children: /* @__PURE__ */ C(Q.Header.Title, { children: "Sub account usage" }) }), e.map((e, t) => /* @__PURE__ */ w(Q.Group, { children: [/* @__PURE__ */ C(Q.Item, {
		title: "Account name",
		titleColSpan: 8,
		children: /* @__PURE__ */ C(E, {
			style: { fontWeight: "bold" },
			children: e.subAccountLabel
		})
	}), e.usageData.map(({ label: e, quantity: t }, n) => /* @__PURE__ */ C(Q.Item, {
		title: e,
		titleColSpan: 8,
		children: /* @__PURE__ */ C(E, { children: t })
	}, n))] }, t))] }) }) : null;
}, to = () => {
	let e = j(Hi), t = j(Ui), n = j(K);
	if (!e || e.length === 0 || !t) return null;
	let r = e.reduce((e, t) => e + parseFloat(t.subtotal || "0"), 0).toString(), i = parseInt(n.lineItemTable.body.rowIndentation.paddingLeft, 10);
	return /* @__PURE__ */ C($, { children: /* @__PURE__ */ w(D, {
		style: n.detailsBlock.container,
		children: [
			/* @__PURE__ */ C(E, {
				style: n.detailsBlock.header.title,
				children: "Seats breakdown"
			}),
			/* @__PURE__ */ w(X, {
				style: n.lineItemTable.header.row,
				wrap: !1,
				children: [
					/* @__PURE__ */ C(Z, {
						colSpan: 6,
						children: /* @__PURE__ */ C(E, {
							style: n.lineItemTable.header.cellText,
							children: "Name"
						})
					}),
					/* @__PURE__ */ C(Z, {
						colSpan: 2,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ C(E, {
							style: n.lineItemTable.header.cellText,
							children: "Days"
						})
					}),
					/* @__PURE__ */ C(Z, {
						colSpan: 2,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ C(E, {
							style: n.lineItemTable.header.cellText,
							children: "Qty"
						})
					}),
					/* @__PURE__ */ C(Z, {
						colSpan: 3,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ C(E, {
							style: n.lineItemTable.header.cellText,
							children: "Rate"
						})
					}),
					/* @__PURE__ */ C(Z, {
						colSpan: 3,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ C(E, {
							style: n.lineItemTable.header.cellText,
							children: "Price"
						})
					})
				]
			}),
			e.map((e, r) => /* @__PURE__ */ w(D, { children: [
				/* @__PURE__ */ C(X, {
					style: n.lineItemTable.body.row,
					wrap: !1,
					children: /* @__PURE__ */ C(Z, {
						colSpan: 16,
						children: /* @__PURE__ */ w(E, {
							style: n.lineItemTable.body.cellTextNameFirstLevel,
							children: [e.groupTitle, e.groupDescription && ` (${e.groupDescription})`]
						})
					})
				}),
				e.lineItems.map((e, r) => /* @__PURE__ */ w(X, {
					style: n.lineItemTable.body.row,
					wrap: !1,
					children: [
						/* @__PURE__ */ C(Z, {
							colSpan: 6,
							style: { paddingLeft: `${i}px` },
							children: /* @__PURE__ */ C(E, {
								style: {
									...n.lineItemTable.body.cellTextBase,
									...n.lineItemTable.body.cellTextNameSecondLevel
								},
								children: e.title
							})
						}),
						/* @__PURE__ */ C(Z, {
							colSpan: 2,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ C(E, {
								style: n.lineItemTable.body.cellTextBase,
								children: e.servicePeriod || "-"
							})
						}),
						/* @__PURE__ */ C(Z, {
							colSpan: 2,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ C(E, {
								style: n.lineItemTable.body.cellTextBase,
								children: e.quantity
							})
						}),
						/* @__PURE__ */ C(Z, {
							colSpan: 3,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ C(E, {
								style: n.lineItemTable.body.cellTextBase,
								children: x({
									value: e.rate,
									currency: t
								})
							})
						}),
						/* @__PURE__ */ C(Z, {
							colSpan: 3,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ C(E, {
								style: n.lineItemTable.body.cellTextBase,
								children: x({
									value: e.netTotal,
									currency: t
								})
							})
						})
					]
				}, r)),
				/* @__PURE__ */ w(X, {
					style: n.lineItemTable.body.row,
					wrap: !1,
					children: [/* @__PURE__ */ C(Z, {
						colSpan: 13,
						children: /* @__PURE__ */ C(E, {
							style: {
								...n.lineItemTable.body.cellTextBase,
								...n.lineItemTable.body.cellTextSecondary
							},
							children: "Subtotal"
						})
					}), /* @__PURE__ */ C(Z, {
						colSpan: 3,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ C(E, {
							style: {
								...n.lineItemTable.body.cellTextBase,
								...n.lineItemTable.body.cellTextSecondary
							},
							children: x({
								value: e.subtotal,
								currency: t
							})
						})
					})]
				})
			] }, r)),
			/* @__PURE__ */ w(X, {
				style: n.lineItemTable.body.row,
				wrap: !1,
				children: [/* @__PURE__ */ C(Z, {
					colSpan: 13,
					children: /* @__PURE__ */ C(E, {
						style: n.lineItemTable.body.cellTextNameFirstLevel,
						children: "Total"
					})
				}), /* @__PURE__ */ C(Z, {
					colSpan: 3,
					style: { textAlign: "right" },
					children: /* @__PURE__ */ C(E, {
						style: n.lineItemTable.body.cellTextNameFirstLevel,
						children: x({
							value: r,
							currency: t
						})
					})
				})]
			})
		]
	}) });
};
//#endregion
//#region src/renderers/PdfInvoiceRenderer/PdfInvoiceRenderer.tsx
Oe();
var no = ({ theme: e, data: t, isProductionEnv: n = !0 }) => (Xe([
	[$n, e],
	[Y, t],
	[Gi, !n]
]), /* @__PURE__ */ w(je, { children: [
	/* @__PURE__ */ C(Xa, {}),
	/* @__PURE__ */ C($a, {}),
	/* @__PURE__ */ C(Za, {}),
	/* @__PURE__ */ C(Qa, {}),
	/* @__PURE__ */ C(eo, {}),
	/* @__PURE__ */ C(to, {})
] })), ro = (e) => /* @__PURE__ */ C(Ke, { children: /* @__PURE__ */ C(no, { ...e }) });
//#endregion
export { Vr as CREDIT_NOTE_LABEL, et as CanadianInternationalPaymentDetails, tt as CanadianPaymentDetails, Hr as DISPLAYED_DECIMAL_PLACES, En as GroupSummary, nt as IbanPaymentDetails, Kn as LineItemsTable, Un as PaymentDetailsModal, ro as PdfInvoiceRenderer, xa as ReactInvoiceRenderer, Cn as ReactPdfCreditNote, Hn as SubAccountUsageBreakdownCard, $e as UkPaymentDetails, rt as UsAchPaymentDetails, it as UsWirePaymentDetails, kr as flattenSubAccountUsage, or as formatAmount, Pr as formatLineItemGroups, Or as formatPaymentDetails, rr as formatQuantity, ir as formatRate, un as formatServicePeriodWithFallback, ar as formatTaxRate, Ir as getInvoiceTitle, Ln as getPaymentAccountDetails, qr as isGrantApplied, sr as lineItemGroupsToBreakdownRows, Lr as resolveServicePeriods, Kr as sumAppliedCreditNoteAmounts, Gr as toAppliedCreditNoteAmount, ei as toAppliedGrantCredit, Wr as toCreditAppliedLabel, Qr as toGrantGrossTotal, Xr as toGrantNetAmount, Zr as toGrantTaxAmount, ri as toSettlementTotals, ti as toTotalAfterCreditGrants };

//# sourceMappingURL=index.js.map